/* eslint-disable @typescript-eslint/no-explicit-any */
import { Component, ElementRef, NgZone, OnInit, ViewChild, HostBinding } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { PicturesPage } from '../pictures/pictures.page';
import { CropperComponent } from 'angular-cropperjs';
import { GenericChoicePage } from '../generic-choice/generic-choice.page';
import { AlertController, ModalController, NavParams, ToastController, Platform, ActionSheetController } from '@ionic/angular';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { LoadingController } from '@ionic/angular';
import { Preferences } from '@capacitor/preferences';
import { UserService } from '@shared/services/user.service';
import { UtilService } from '@shared/utils/util';
import { EmailValidationPage } from '../email-validation/email-validation.page';
import { GenericInputPage } from '../generic-input/generic-input.page';
import { InterestPage } from '../interest/interest.page';
import { HeightPage } from '../height/height.page';
import { LookingForPage } from '../looking-for/looking-for.page';
import { Filesystem, Directory } from '@capacitor/filesystem';
import { LocationService } from '@shared/services/location.service';
import { Observable, firstValueFrom } from 'rxjs';
import { DomSanitizer } from '@angular/platform-browser';
import { Camera, CameraResultType, CameraSource, Photo, } from '@capacitor/camera';
import { ReferralConfirmationPage } from '../referral-confirmation/referral-confirmation.page';
import { PurchaseService } from 'src/app/services/purchase.service';
import { StoreV2Page } from '../store-v2/store-v2.page';
import { ActivatedRoute, Router } from '@angular/router';
import 'hammerjs';
import { AnalyticsService } from 'src/app/services/analytics.service';
import { AndroidSettings, IOSSettings, NativeSettings } from 'capacitor-native-settings';
import { ValidationCompletedComponent } from '@shared/components/validation-completed/validation-completed.component';
import { NewPhotoNotApprovedComponent } from '@shared/components/new-photo-not-approved/new-photo-not-approved.component';
import { NewPhotoValidationComponent } from '@shared/components/new-photo-validation/new-photo-validation.component';
import { ProfileAlreadyValidatedComponent } from '@shared/components/profile-already-validated/profile-already-validated.component';
import { Capacitor, PluginListenerHandle } from '@capacitor/core';
import { Keyboard } from '@capacitor/keyboard';
import { NotAvailableComponent } from '@shared/components/not-available/not-available.component';
import { environment } from 'src/environments/environment';
import { OnboardingService } from '@shared/services/onboarding.service';

/**
 * Edicao de UMA foto da leva: filtro, ajustes, transformacoes e a area de recorte.
 *
 * Existe para a edicao viajar junto da foto na tira de miniaturas. Sem isto, trocar de foto
 * perdia o trabalho: `resetEditorState()` zera os valores e a troca de imagem refaz a caixa
 * do cropperjs.
 */
interface EdicaoDaFoto {
  filtro: string;
  zoom: number;
  endireitar: number;
  rotacao: number;
  escalaX: number;
  escalaY: number;
  adj: { bright: number; contrast: number; sat: number; warm: number };
  recorte: unknown;
}

@Component({
  selector: 'app-profile',
  templateUrl: './profile.page.html',
  styleUrls: ['./profile.page.scss'],
  providers: [UserService, UtilService, NavParams]
})
export class ProfilePage implements OnInit {
  @ViewChild('angularCropper')
  public angularCropper: CropperComponent = new CropperComponent;
  cropperOptions: any;
  croppedImage: any = null;
  showCropper: boolean = false;
  private denyCount = 0;

  myImage: any = null;
  scaleValX = 1;
  scaleValY = 1;

  // Editor de foto (abas: Recortar / Ajustar / Filtros), baseado no prototipo.
  // Preview reativo via [style.filter] no template; no export o filtro e "assado"
  // no canvas (bakeFilter), pois getCroppedCanvas NAO carrega o filtro CSS.
  editorTab: 'recortar' | 'ajustar' | 'filtros' = 'recortar';
  activeFilter = 'none';                 // preset selecionado
  previewFilter: string | null = null;   // filtro composto (preset + ajustes)
  zoomVal = 1;                           // posicao do slider de zoom
  straightenVal = 0;                     // graus de endireitar
  private baseRotation = 0;              // rotacao acumulada em passos de 90
  adj = { bright: 1, contrast: 1, sat: 1, warm: 0 };
  readonly filterPresets: { labelKey: string; css: string }[] = [
    { labelKey: 'cropOriginal', css: 'none' },
    { labelKey: 'cropVivid', css: 'saturate(1.6) contrast(1.1)' },
    { labelKey: 'cropBW', css: 'grayscale(1) contrast(1.05)' },
    { labelKey: 'cropWarm', css: 'sepia(.4) saturate(1.3)' },
  ];

  private loader = this.loadingCtrl.create({
    message: this.translate.instant('msgOneMomentPlease'),
  });

  // Profile Image Related
  public shuffling: boolean = false;
  public grayPlus: string = PicturesPage.grayPlus;
  public pictures: string[] = Array(9).fill(PicturesPage.grayPlus);
  private preShufflePictures: string[] = [];
  private lastReorderValidationWarningAt = 0;
  private readonly reorderValidationWarningCooldownMs = 1500;
  private picChanged: boolean[] = [false, false, false, false, false, false, false, false, false];
  /** Uma exclusao por vez — ver o cabecalho do `deleteFile`. */
  private excluindoFoto: boolean = false;
  
  // Long-press delay lets Sortable start drag on the same hold (no release required).
  public sortablejsOptions = this.buildSortableOptions();

  private isNative: boolean = true;
  private workingOnIndex: number = 0;
  private index: number | undefined;

  public dietSinceDate_aux: string = "";

  public myForm: any;
  submitAttempt: boolean = false;
  public userData: any;
  public isFirstSetup: boolean = false;
  private changed: boolean = false;
  private theNameControl: FormControl =
    new FormControl('', Validators.compose([Validators.required, Validators.maxLength(100), Validators.minLength(2)]));
  private theGenderControl: FormControl = new FormControl('', Validators.required);
  private theInterestControl: FormControl = new FormControl('', Validators.required);
  private theDietControl: FormControl = new FormControl('', Validators.required);
  private theSinceControl: FormControl = new FormControl('');
  private theAgeControl: FormControl =
    new FormControl('', Validators.compose([Validators.required, Validators.min(18), Validators.max(100)]));
  private cityControl: FormControl = new FormControl('', Validators.maxLength(50));
  private theAboutControl: FormControl = new FormControl('', Validators.maxLength(1000));
  private theWorkControl: FormControl = new FormControl('', Validators.maxLength(100));
  private theLanguageControl: FormControl = new FormControl('', Validators.required);
  private theDistanceUnitControl: FormControl = new FormControl('', Validators.required);
  private referralEmailControl: FormControl = new FormControl('', Validators.maxLength(50));
  private limitDate = new Date();
  public aboutData: string = "";
  private today = this.limitDate.getFullYear + '-' + this.limitDate.getMonth() + '-' + this.limitDate.getDay();
  public date = new Date();
  public now: any = this.date.toISOString().slice(0, 10);


  public charsRemainingInput: number = 1000;

  public showAvocadoClubIndicator: boolean = false;

  // Detecção de iPad/Tablet
  public isIpad: boolean = false;
  public isTablet: boolean = false;
  public userIsPremium: boolean = false;

  // About me section expansion
  public aboutMeExpanded: boolean = false;
  private documentClickHandler?: (event: Event) => void;

  public imageTest: string = ""

  public missingInformation: boolean = false;

  constructor(
    private translate: TranslateService,
    private router: Router,
    private route: ActivatedRoute,
    private modalCtrl: ModalController,
    private loadingCtrl: LoadingController,
    public navParams: NavParams,
    public userService: UserService,
    public util: UtilService,
    public toastCtrl: ToastController,
    private alertCtrl: AlertController,
    public locationSvc: LocationService,
    private sanitizer: DomSanitizer,
    private platform: Platform,
    public actionSheetCtrl: ActionSheetController,
    private analytics: AnalyticsService,
    private purchaseServiceProvider: PurchaseService,
    private ngZone: NgZone,
    private onboardingService: OnboardingService,
    private elementoHost: ElementRef<HTMLElement>,
  ) {

    // this.translate.setDefaultLang('pt');
    this.util.initTranslate();

    this.showAvocadoClubIndicator = this.navParams.get("showAvocadoClubIndicator");

    this.myForm = new FormGroup({
      nameControl: this.theNameControl,
      genderControl: this.theGenderControl,
      interestControl: this.theInterestControl,
      dietControl: this.theDietControl,
      sinceControl: this.theSinceControl,
      ageControl: this.theAgeControl,
      cityControl: this.cityControl,
      aboutControl: this.theAboutControl,
      workControl: this.theWorkControl,
      languageControl: this.theLanguageControl,
      distanceUnitControl: this.theDistanceUnitControl,
      referralEmailControl: this.referralEmailControl
    });

    this.setupPictures();

    this.loadView(true);
  }

  ngOnInit(): void {
    // Detecção de iPad/Tablet
    this.isIpad = this.platform.is('ipad') || (this.platform.is('ios') && window.innerWidth >= 768);
    this.isTablet = this.isIpad || (this.platform.is('android') && window.innerWidth >= 768);
    
    // Debug para verificar detecção
    console.log('Profile - iPad detected:', this.isIpad);
    console.log('Profile - Tablet detected:', this.isTablet);
    console.log('Profile - Window width:', window.innerWidth);
    console.log('Profile - Platform:', this.platform.platforms());

    // Prevenir arrasto de imagens no Android 15
    if (this.platform.is('android')) {
      this.preventImageDrag();
    }

    // Add click listener to collapse about me section when clicking outside
    this.documentClickHandler = this.handleDocumentClick.bind(this);
    document.addEventListener('click', this.documentClickHandler);
  }
  
  /**
   * Previne o arrasto de imagens no Android 15 quando NÃO está no modo shuffling
   * Adiciona listeners para prevenir dragstart e touchmove que causam arrasto
   * Permite arrasto quando está no modo shuffling para reordenar fotos
   */
  private preventImageDrag(): void {
    // Aguarda um pouco para garantir que os elementos estejam renderizados
    setTimeout(() => {
      this.updateImageDragState();
    }, 100);
  }
  
  /**
   * Atualiza o estado de arrasto das imagens baseado no modo shuffling
   */
  private updateImageDragState(): void {
    // No modo shuffling, não fazer nada - deixar o nxtSortablejs controlar
    if (this.shuffling) {
      // Apenas remover listeners de prevenção se existirem, mas não interferir com sortablejs
      const images = document.querySelectorAll('.boxes:not(.shuffling-active) img');
      const imgWrappers = document.querySelectorAll('.boxes:not(.shuffling-active) .img-wrapper');
      
      images.forEach((img) => {
        if (img instanceof HTMLElement && (img as any).__dragHandler) {
          img.removeEventListener('dragstart', (img as any).__dragHandler);
          (img as any).__dragPrevented = false;
          (img as any).__dragHandler = null;
        }
      });
      
      imgWrappers.forEach((wrapper) => {
        if (wrapper instanceof HTMLElement && (wrapper as any).__dragHandler) {
          wrapper.removeEventListener('dragstart', (wrapper as any).__dragHandler);
          (wrapper as any).__dragPrevented = false;
          (wrapper as any).__dragHandler = null;
        }
      });
      return; // Sair cedo no modo shuffling - deixar sortablejs fazer seu trabalho
    }
    
    // Modo normal: prevenir arrasto do Android 15
    const images = document.querySelectorAll('.boxes img');
    const imgWrappers = document.querySelectorAll('.boxes .img-wrapper');
    
    images.forEach((img) => {
      if (img instanceof HTMLElement) {
        img.setAttribute('draggable', 'false');
        // Adiciona listener apenas se ainda não tiver
        // Usa uma flag para evitar múltiplos listeners
        if (!(img as any).__dragPrevented) {
          const handler = (e: Event) => {
            e.preventDefault();
            e.stopPropagation();
            return false;
          };
          img.addEventListener('dragstart', handler, { passive: false });
          (img as any).__dragPrevented = true;
          (img as any).__dragHandler = handler;
        }
      }
    });
    
    imgWrappers.forEach((wrapper) => {
      if (wrapper instanceof HTMLElement) {
        wrapper.setAttribute('draggable', 'false');
        if (!(wrapper as any).__dragPrevented) {
          const handler = (e: Event) => {
            e.preventDefault();
            e.stopPropagation();
            return false;
          };
          wrapper.addEventListener('dragstart', handler, { passive: false });
          (wrapper as any).__dragPrevented = true;
          (wrapper as any).__dragHandler = handler;
        }
      }
    });
  }

  async showNotAvailableModal() {
    const modal = await this.modalCtrl.create({
      component: NotAvailableComponent,
      componentProps: {
        downloadLink: environment.adjustDownloadLink
      },
      cssClass: 'custom-class-modal'
    });

    await modal.present();

    modal.onDidDismiss().then(() => {
      // Usuário permanece na tela do profile
    });
  }



  private setupPictures() {
    this.cropperOptions = {
      viewMode: 1,
      dragMode: 'crop',
      aspectRatio: 4 / 5, // 4:5 (retrato) — o wrapper aplica este aspectRatio, travando em vertical
      // `minCroppedWidth: 320` morava aqui e NAO EXISTE no cropperjs 1.6.2 — era uma protecao
      // que nunca protegeu nada. O piso de verdade esta no `getCroppedCanvas` do export.

      // 0 nos dois: o cropperjs grampeia o container em 200x100 por padrao
      // (`cropper.js` ~1165, `Math.max(container.offsetWidth, 200)`). Em caixa mais estreita
      // que isso — web em paisagem, janela baixa — o `getContainerData()` passava a descrever
      // uma caixa FANTASMA, e o `enquadrar` centralizava contra algo que nao esta na tela.
      minContainerWidth: 0,
      minContainerHeight: 0,
      autoCrop: true,
      movable: true,
      zoomable: true,
      scalable: true,
      // 1, e nao 0.8: o recorte inicial passa a ser a MAIOR area 4:5 que cabe na foto, em vez
      // de 80% dela. Com 0.8, abrir o editor ja descartava 20% da foto sem o usuario pedir — e
      // era parte do "abre pequena".
      autoCropArea: 1,

      // Desliga o xadrez de transparencia da lib. Ele existia e nunca se via, porque a foto
      // sempre preenchia o container; agora que ela e CONTIDA na caixa 4:5, as bandas de
      // sobra ficariam cobertas por um quadriculado cinza. Com isto, a sobra e o fundo da
      // propria caixa — preto, como a tarja de um editor de foto.
      background: false
    };

    Preferences.get({ key: 'USER_DATA' }).then((val) => {
      this.userData = val.value ? JSON.parse(val.value) : null;
      this.loadImages();
    });


    this.isNative = this.util.isNative();
  }

  private loadImages() {
    let i;
    for (i = 0; i < this.pictures.length; i++) {
      const aPic: string = 'picture' + i;
      const aPicValue = this.userData[aPic];
      if (aPicValue != undefined && aPicValue != null) {
        const imgUrl = this.userService.getImageURL(aPicValue.$oid); //this.soulService.getBaseURL() + '/soul/image/' + aSoul[aPic].$oid; // Set the URL here as last resort
        console.log('imgUrl: ' + imgUrl);
        this.pictures[i] = imgUrl;

      } else {
        // O slot vazio PRECISA ser escrito. Sem este ramo o laco so atribuia, nunca esvaziava,
        // e `this.pictures` e um campo que sobrevive entre entradas na tela: uma foto excluida
        // continuava desenhada ali. Medido: com A B C, excluindo B e C, sair e voltar mostrava
        // A B C de novo — inclusive o B, que havia sido apagado DE VERDADE no servidor, ou
        // seja, a tela exibia uma foto que nao existia em lugar nenhum.
        this.pictures[i] = PicturesPage.grayPlus;
      }
    }

  }



  protected dietSinceDate: Date = new Date();

  protected openDatePicker: boolean = false;
  protected fromDate = "1950-01-01";

  private loadView(_isFirstTime: boolean) {
    Preferences.get({ key: 'USER_DATA' }).then(async (val) => {
      this.userData = val.value ? JSON.parse(val.value) : null;

      if (this.userData == null) {
        this.router.navigateByUrl('/login');
        return;
      }

      console.log('profile - this.userData: ' + JSON.stringify(this.userData));

      this.isFirstSetup = await this.resolveIsFirstSetup(this.userData);

      const rawLanguage = this.userData.language == null
        ? this.translate.getBrowserLang()
        : this.userData.language;
      // Distance unit must use the raw browser/profile language; normalizeLanguage
      // maps unsupported codes to EN and would incorrectly force miles.
      if (this.userData.distanceUnit == null) {
        const rawBase = UtilService.languageBaseCode(rawLanguage) || 'en';
        this.userData.distanceUnit = rawBase === 'en' ? 'mi' : 'km';
      }
      this.userData.language = UtilService.normalizeLanguage(rawLanguage);


      if (this.userData.since != null) {

        this.dietSinceDate = new Date(this.userData.since);
      }
      //      console.log('profile - this.userData: ' + JSON.stringify(this.userData));
      console.log('profile - this.userData.gender: ' + this.userData.gender);


      if (this.userData.age != null) {
        this.myForm.controls['ageControl'].setValue(this.userData.age);
      } else {
        if (this.userData.birth != null) {
          //          let calcAge = this.calculateAge(new Date('08/01/1979'));
          // TODO test it's working when birth is coming from Facebook
          console.log('profile - this.userData.birth: ' + this.userData.birth);
          const calcAge = this.userService.calculateAge(new Date(this.userData.birth));
          this.myForm.controls['ageControl'].setValue(calcAge);

        }

      }


      if (this.userData.about != null) {
        this.aboutData = this.userData.about;
        // this.adjust();
      }

      this.submitAttempt = false;
    })
  }

  private async resolveIsFirstSetup(userData: any): Promise<boolean> {
    if (userData == null) {
      return false;
    }
    if (userData.interest == null && userData.interest2 == null) {
      return true;
    }
    const pendingPhoto = await this.onboardingService.hasPendingPhotoSetup();
    return pendingPhoto && !this.userService.checkUserHasPicture(userData);
  }

  async backPage() {
    this.resetReorderInteractionLocks();

    if (this.shuffling) {
      await this.saveOrder();
    }

    await this.savePicturesOnUserData(this.pictures);
    if (!this.userService.checkUserHasPicture(this.userData)) {
      this.showModalAlertSavingProfileWithoutPicture()
    } else {
      await this.save();
      if (!Capacitor.isNativePlatform() && await this.userService.consumeReferralJoinPending()) {
        this.openModalDownloadApp()
      } else {
        await this.userService.clearReferralJoinContext();
        const loader = this.loadingCtrl.create({
          message: this.translate.instant('pleaseWait'),
        });
        (await loader).present();
        setTimeout(async () => {
          (await loader).dismiss();
          this.modalCtrl.dismiss();

        }, 1000);
      }
    }
  }

  async showModalAlertSavingProfileWithoutPicture() {
    const alert = this.alertCtrl.create({
      subHeader: this.translate.instant('yourProfileWontBeShownUnlessYouUploadOnePicture'),
      buttons: [{
        text: this.translate.instant('saveAndExit'),
        handler: async () => {
          console.log('save and exit clicked');
          this.missingInformation = this.userData.diet == null || this.userData.gender2 == null || this.userData.interest2 == null
            || this.userData.firstName == null || this.userData.age == null || this.userData.city == null;
          if (this.missingInformation) {
            this.alertMissingInformation();
            return;
          }
          await this.save();
          if (!Capacitor.isNativePlatform() && await this.userService.consumeReferralJoinPending()) {
            this.openModalDownloadApp()
          } else {
            await this.userService.clearReferralJoinContext();
            setTimeout(() => {
              // this.router.navigateByUrl('/tabs/home', { skipLocationChange: true }).then(() => {
              //   this.router.navigate(['/tabs/my-profile-display']);
              // });
              this.modalCtrl.dismiss();
            }, 1000);
          }
          return;
        }
      },
      {
        text: this.translate.instant("uploadNow"),
        handler: () => {
          console.log('upload now clicked');
          return;
        }
      }
      ]

    });

    (await alert).present();
  }

  async openModalDownloadApp() {
    const modal = this.modalCtrl.create({ component: ReferralConfirmationPage });
    (await modal).onDidDismiss().then(async (val) => {
      await this.userService.clearReferralJoinContext();

      setTimeout(() => {
        this.modalCtrl.dismiss();
      }, 1000);


      if (val && val.data === "logout") {
        this.router.navigateByUrl('/login');
        return;
      }

    });

    (await modal).present();
  }


  async save() {
    this.submitAttempt = true;

    await this.savePicturesOnUserData(this.pictures);

    await this.saveLocally();

    /*
    let loader = this.loadingCtrl.create({
      content: this.translate.instant('pleaseWait'),
    });
    loader.present();*/

    let theObs: Observable<any>;

    await Preferences.get({ key: 'LAST_LOCATION' }).then(async (val) => {
      val = val.value ? JSON.parse(val.value) : null;
      let location = val;
      const teleportationLocation = this.locationSvc.getTeleportationLocation();
      if (teleportationLocation != null) {
        location = teleportationLocation;
      }

      this.userData.showAvocadoClubIndicator = this.showAvocadoClubIndicator;

      // Retrieve and add FCM token to userData before sending to server
      const fcmToken = await Preferences.get({ key: 'TOKEN' });
      if (fcmToken && fcmToken.value) {
        this.userData.token = fcmToken.value;
      } else {
        const localToken = localStorage.getItem('TOKEN');
        if (localToken) {
          this.userData.token = localToken;
        }
      }

      theObs = await this.userService.upsertSoul(this.userData, location, false, false, false)

      theObs.subscribe(async data => {
        console.log('profile - upsert subscribe entered');
        console.log(JSON.stringify(data));


        if (data != '{not ok}') {
          const userData = JSON.parse(data);
          console.log(userData.showAvocadoClubIndicator);
          await Preferences.set({ key: 'USER_DATA', value: JSON.stringify(userData) }).then((_val) => {
            console.log('userdata saved to DB');
          })


          this.changed = false;
          //loader.dismiss();
          if (this.isFirstSetup && userData.receivedReferralCoin) {
            const fromUpsert = this.userService.resolveReferralSource(userData);
            if (fromUpsert === 'affiliate') {
              await this.userService.setReferralSource('affiliate');
            }
            const source = await this.userService.getReferralSource();
            const messageKey = source === 'affiliate'
              ? 'congratsAffiliateReferralReceivedCoins'
              : 'congratsYouAndFriendReceivedCoin';
            const alert = this.alertCtrl.create({
              message: this.translate.instant(messageKey),
              buttons: [
                {
                  text: 'OK',
                  role: 'cancel',
                  handler: () => {
                    //this.editPictures();
                  }
                }
              ]
            });
            (await alert).present();

          }

          if (this.isFirstSetup) {
            this.analytics.registerEvent(AnalyticsService.signUpEvent);
            if (this.userService.checkUserHasPicture(userData)) {
              this.analytics.registerEvent(AnalyticsService.signUpComplete, true);
              this.analytics.registerEvent(AnalyticsService.loginOrSignUpCompl, true);
            }
          }

          this.isFirstSetup = false;
          await this.onboardingService.clearPendingPhotoSetup();
        } else {
          //loader.dismiss();
        }



      },
        err => {
          this.util.showToastUnableToConnect(this.toastCtrl);
          console.log('Error: ' + JSON.stringify(err));
          //alert('Invalid email or password. Please, try again');
          // loader.dismiss();
        })
    });




  }

  private saveLocally() {
    if (this.isFirstSetup) {
      this.userData.coins = 1;
      this.userData.receivedCoins = true;
    }
    if (this.userData.age != null && typeof this.userData.age == "string") {
      this.userData.age = parseInt(this.userData.age);
    }
    this.userData.about = this.aboutData;

    Preferences.set({ key: 'USER_DATA', value: JSON.stringify(this.userData) }).then((_val) => {
      console.log('userdata saved to DB');
    });
  }

  setShowAvocadoClubIndicator() {
    this.showAvocadoClubIndicator = !this.showAvocadoClubIndicator;
  }

  async goToAvocadoClubIndicator() {
    this.showModalAlertNeedToHaveAvocadoClub()
  }

  async showModalAlertNeedToHaveAvocadoClub() {
    const alert = this.alertCtrl.create({
      subHeader: this.translate.instant('joinClubAndShowInYourProfile'),
      buttons: [{
        text: this.translate.instant('cancel'),
        handler: () => {
          console.log('cancel clicked');
          return;
        }
      },
      {
        text: this.translate.instant('joinClub'),
        handler: async () => {
          console.log('Join club clicked');
          this.analytics.registerEvent(AnalyticsService.avocado);
          this.analytics.registerEvent(AnalyticsService.avcdFromIndicator);
          const modal = this.modalCtrl.create({ component: StoreV2Page, componentProps: { me: this.userData, type: 'avocado_club', from: "joinClub" }, showBackdrop: true, backdropDismiss: true });
          (await modal).present();
          (await modal).onDidDismiss().then((_val) => {
            this.userIsPremium = this.purchaseServiceProvider.isPremium(this.userData);
            if (this.userIsPremium) {
              this.showAvocadoClubIndicator = true;
              Preferences.set({ key: 'showedAvocadoClubPopup', value: JSON.stringify(true) }).then((_val) => {
                console.log('showedAvocadoClubPopup saved to DB');
              });
            }
          });

          return;
        }
      }
      ]

    });

    (await alert).present();
  }

  setChanged() {
    this.changed = true;
    console.log('setChanged called..');
  }


  dateSelected(e: any) {

    // e.setDate(e.getDate() - 1);
    // console.log(e.toISOString().slice(0, 10));
    // console.log(String(e).slice(0, 10));
    // console.log(new Date(e).toLocaleDateString('en-US', {timeZone: 'UTC'}));
    // console.log(e.toLocaleDateString('pt-BR'));
    // console.log(new Date(e).toISOString().slice(0, 10));
    // e.setDate(1);

    //alert(e.getFullYear()+ '-' + (e.getMonth()+1) + '-' + e.getDate());
    //alert(e.toISOString().slice(0,10));

    this.setChanged();
    try {
      e = new Date(e.detail.value);
      let aux = e.toISOString().slice(0, 10);
      aux = aux.slice(0, -2) + "01";

      e = new Date(aux);
      this.dietSinceDate = e;
      this.userData.since = String(aux);
    } catch {
      let aux: any = Date.now();
      e = new Date(aux)
      aux = e.toISOString().slice(0, 10);
      aux = aux.slice(0, -2) + "01";
      this.dietSinceDate = e;
      this.userData.since = String(aux);
    }


    this.openDatePicker = false;
  }

  saveDietSinceDate() {
    this.setChanged();
    this.userData.since = this.dietSinceDate;

    //alert(this.userData.since);
  }


  getCharsLeft() {
    return this.charsRemainingInput - this.aboutData.length;
  }

  getCharStatus() {
    if (this.getCharsLeft() <= this.charsRemainingInput && this.getCharsLeft() >= 10) {
      return " full";

    } else if (this.getCharsLeft() < 10 && this.getCharsLeft() > 0) {
      return " filling";

    } else if (this.getCharsLeft() == 0) {
      return " empty";

    } else {
      return " negative"
    }
  }

  setModals(pageName: string, isGeneric: boolean, genericType: string, pageInfo: any) {
    // console.log(isGeneric);
    // console.log(pageInfo);
    console.log(this.userData);

    // return this.modalCtrl.create({component: GenericChoicePage, componentProps: { theSoul: this.userData, pageParameters: pageInfo }});
    //checks if the modal's generic or not
    switch (isGeneric) {
      case true:
        if (genericType == 'choice') {
          return this.modalCtrl.create({ component: GenericChoicePage, componentProps: { theSoul: this.userData, pageParameters: pageInfo } });

        } else {
          return this.modalCtrl.create({ component: GenericInputPage, componentProps: { theSoul: this.userData, pageParameters: pageInfo } });
          // return this.modalCtrl.create(GenericInputPage, { theSoul: this.userData, pageParameters: pageInfo });

        }

      //if not, it sets them manually
      case false:
        switch (pageName) {
          case 'interest':
            return this.modalCtrl.create({ component: InterestPage, componentProps: { theSoul: this.userData, firstSetup: this.isFirstSetup } });
            // return this.modalCtrl.create(InterestPage, { theSoul: this.userData, firstSetup: this.isFirstSetup });
            return
          case 'height':
            return this.modalCtrl.create({ component: HeightPage, componentProps: { theSoul: this.userData, firstSetup: this.isFirstSetup } });
            // return this.modalCtrl.create(HeightPage, { theSoul: this.userData });
            return
          case 'lookingFor':
            return this.modalCtrl.create({ component: LookingForPage, componentProps: { theSoul: this.userData } });
            // return this.modalCtrl.create(LookingForPage, { theSoul: this.userData });
            return
        }


    }
    return

  }

  protected activeFocus: boolean = true;

  //sets profile view status
  setActiveFocus(focus: boolean) {
    this.activeFocus = focus;

  }

  setPageInfo(page: string | null) {

    interface GenericChoiceInterface {
      logoURL: string,
      text: string,
      options: { value: any, label: string }[],
      fieldName: string,
      selectMultipleAllowed: boolean,
      previousPage: string | any,
      nextPage: string | any,
      validator: Validators | any,
      greySection: boolean,
      firstSetup: boolean,
      unselectable: boolean,
      showBackgroundCircle?: boolean,
      stroke?: boolean,
      nopadding?: boolean
    }


    interface GenericInputInterface {
      logoURL: string,
      text: string,
      valuePlaceHolder: string,
      fieldName: string,
      previousPage: string,
      nextPage: string | any,
      validator: Validators | any,
      maxLength: number,
      firstSetup: boolean,
      showBackgroundCircle?: boolean,
      nostroke?: boolean,
      nopadding?: boolean
    }

    interface DefaultPageInterface {
      fieldName: string,
      previousPage: string,
      nextPage: string | any
    }

    switch (page) {

      case 'diet':
        const dietInfo: GenericChoiceInterface = {
          logoURL: '/assets/imgs/custom-svg/padronized-sizes/diet.svg',
          text: this.translate.instant('selectDietMsg'),
          options: [{ value: 'vegan', label: this.translate.instant('vegan') },
          { value: 'vegetarian', label: this.translate.instant('vegetarian') },
          { value: 'working', label: this.translate.instant('working') }
          ],
          fieldName: 'diet',
          selectMultipleAllowed: false,
          previousPage: null,
          nextPage: 'gender', // case firstSetup then 'willingToHelp' or 'lookingForHelp'
          validator: null,
          greySection: false,
          firstSetup: this.isFirstSetup,
          unselectable: false,
          showBackgroundCircle: true,
        }

        this.openModalsRenewed(dietInfo.fieldName, dietInfo.nextPage, null, dietInfo, true, 'choice');
        break;

      case 'willingToHelp':
        const willingToHelpInfo: GenericChoiceInterface = {
          logoURL: '/assets/imgs/custom-svg/padronized-sizes/willingToHelp.svg',
          text: this.translate.instant('areYouWillingToHelpPeopleGoVegan'),
          options: [{ value: true, label: this.translate.instant('yes') },
          { value: false, label: this.translate.instant('no') }
          ],
          fieldName: 'willingToHelp',
          selectMultipleAllowed: false,
          previousPage: 'diet', // if not firstSetup then 'pet'
          nextPage: 'gender', // if not firstSetup then null
          validator: null,
          greySection: false,
          firstSetup: this.isFirstSetup,
          unselectable: false,
          showBackgroundCircle: true,
        }

        this.openModalsRenewed(willingToHelpInfo.fieldName, willingToHelpInfo.nextPage, willingToHelpInfo.previousPage, willingToHelpInfo, true, 'choice');
        break;

      case 'lookingForHelp':
        console.log("LookingForHelp");
        const lookingForHelpInfo: GenericChoiceInterface = {
          logoURL: 'assets/imgs/raise-hand.svg',
          text: this.translate.instant('areYouLookingForHelpToGoVegan'),
          options: [{ value: true, label: this.translate.instant('yes') },
          { value: false, label: this.translate.instant('no') }
          ],
          fieldName: 'lookingForHelp',
          selectMultipleAllowed: false,
          previousPage: 'diet', // if not firstSetup then 'pet'
          nextPage: 'gender', // if not firstSetup then null
          validator: null,
          greySection: false,
          firstSetup: this.isFirstSetup,
          unselectable: false,
          showBackgroundCircle: true,
        }

        this.openModalsRenewed(lookingForHelpInfo.fieldName, lookingForHelpInfo.nextPage, lookingForHelpInfo.previousPage, lookingForHelpInfo, true, 'choice');
        break;

      case 'gender':
        const genderInfo: GenericChoiceInterface = {
          logoURL: '/assets/imgs/custom-svg/padronized-sizes/gender.svg',
          text: this.translate.instant('whatIsYourGender'),
          options: [{ value: 'female', label: this.translate.instant('woman') },
          { value: 'male', label: this.translate.instant('man') },
          { value: 'other', label: this.translate.instant('nonBinaryGenderDiverse') }
          ],
          fieldName: 'gender2',
          selectMultipleAllowed: false,
          previousPage: 'diet', // case firstSetup then 'willingToHelp' or 'lookingForHelp'
          nextPage: 'interest',
          validator: Validators.compose([Validators.required, Validators.maxLength(30), Validators.minLength(2)]),
          greySection: false,
          firstSetup: this.isFirstSetup,
          unselectable: false,
          showBackgroundCircle: true,
        };

        this.openModalsRenewed('gender', genderInfo.nextPage, genderInfo.previousPage, genderInfo, true, 'choice');
        break;

      case 'interest':

        const interestInfo: DefaultPageInterface = {
          fieldName: 'interest',
          previousPage: 'gender',
          nextPage: 'name'
        }

        this.openModalsRenewed(interestInfo.fieldName, interestInfo.nextPage, interestInfo.previousPage, null, false, '');
        break;

      case 'name':
        const nameInfo: GenericInputInterface = {
          logoURL: '/assets/imgs/custom-svg/padronized-sizes/name.svg',
          text: this.translate.instant('wouldLikeToBeCalled'),
          valuePlaceHolder: this.translate.instant('yourName'),
          fieldName: 'firstName',
          previousPage: 'interest',
          nextPage: 'age',
          validator: Validators.compose([Validators.required, Validators.pattern("^(?![0-9]).*"), Validators.maxLength(50), Validators.minLength(2)]),
          maxLength: 50,
          firstSetup: this.isFirstSetup,
          showBackgroundCircle: true,
        };

        //alert(JSON.stringify(nameInfo));

        //pageName : string, nextPage : string, pastPage : string, pageInfo : any, isGeneric : boolean, genericType : string
        this.openModalsRenewed(nameInfo.fieldName, nameInfo.nextPage, nameInfo.previousPage, nameInfo, true, 'input');

        break;

      case 'age':
        const ageInfo: GenericInputInterface = {
          logoURL: '/assets/imgs/custom-svg/padronized-sizes/age.svg',
          text: this.translate.instant('whatIsYourAge'),
          valuePlaceHolder: this.translate.instant('yourAge'),
          fieldName: 'age',
          previousPage: 'name',
          nextPage: 'city',
          validator: Validators.compose([Validators.required, Validators.pattern("^[0-9]*$"), Validators.maxLength(2), Validators.minLength(2), Validators.min(18), Validators.max(100)]),
          maxLength: 2,
          firstSetup: this.isFirstSetup,
          showBackgroundCircle: true,
        };

        //pageName : string, nextPage : string, pastPage : string, pageInfo : any, isGeneric : boolean, genericType : string        
        this.openModalsRenewed(ageInfo.fieldName, ageInfo.nextPage, ageInfo.previousPage, ageInfo, true, 'input');
        break;

      case 'city':
        const cityInfo: GenericInputInterface = {
          logoURL: '/assets/imgs/custom-svg/padronized-sizes/location.svg',
          text: this.translate.instant('city'),
          valuePlaceHolder: this.translate.instant('insertCityHere'),
          fieldName: 'city',
          previousPage: 'age',
          nextPage: null,
          validator: Validators.compose([Validators.required, Validators.pattern("^(?![0-9]).*"), Validators.maxLength(50), Validators.minLength(3)]), // standard without accents: ^[a-zA-Z]+(?:[\s-][a-zA-Z]+)*$
          maxLength: 50,
          firstSetup: this.isFirstSetup,
          showBackgroundCircle: true,
          nopadding: true,
        };

        this.openModalsRenewed(cityInfo.fieldName, cityInfo.nextPage, cityInfo.previousPage, cityInfo, true, 'input');
        break;


      case 'activism':
        const activismInfo: GenericChoiceInterface = {
          logoURL: '/assets/imgs/custom-svg/padronized-sizes/activism.svg',
          text: this.translate.instant('whatIsYourActivismLevel'),
          options: [{ value: 'activist', label: this.translate.instant('activist') },
          { value: 'someInThePast', label: this.translate.instant('someInThePast') },
          { value: 'willingToDo', label: this.translate.instant('willingToDo') },
          { value: 'lowProfile', label: this.translate.instant('lowProfile') }
          ],
          fieldName: 'activism',
          selectMultipleAllowed: false,
          previousPage: null,
          nextPage: 'work',
          validator: null,
          greySection: false,
          firstSetup: false,
          unselectable: true,
          stroke: true,
          nopadding: true,
        };

        this.openModalsRenewed(activismInfo.fieldName, activismInfo.nextPage, activismInfo.previousPage, activismInfo, true, 'choice');
        break;

      case 'work':
        const workInfo: GenericInputInterface = {
          logoURL: '/assets/imgs/custom-svg/padronized-sizes/work.svg',
          text: this.translate.instant('workAs'),
          valuePlaceHolder: this.translate.instant('yourWork'),
          fieldName: 'work',
          previousPage: 'activism',
          nextPage: 'education',
          validator: Validators.compose([Validators.maxLength(50)]),
          maxLength: 50,
          firstSetup: false,
          showBackgroundCircle: true,
          nopadding: true,
        };

        this.openModalsRenewed(workInfo.fieldName, workInfo.nextPage, workInfo.previousPage, workInfo, true, 'input');
        break;

      case 'education':
        const educationInfo: GenericChoiceInterface = {
          logoURL: '/assets/imgs/custom-svg/padronized-sizes/education.svg',
          text: this.translate.instant('whatIsYourEducation'),
          options: [
            { value: 'noFormalEducation', label: this.translate.instant('noFormalEducation') },
            { value: 'secondaryIncomplete', label: this.translate.instant('secondaryIncomplete') },
            { value: 'secondaryComplete', label: this.translate.instant('secondaryComplete') },
            { value: 'superiorIncomplete', label: this.translate.instant('superiorIncomplete') },
            { value: 'superiorComplete', label: this.translate.instant('superiorComplete') },
            { value: 'postGraduate', label: this.translate.instant('postGraduate') },
            { value: 'doctorate', label: this.translate.instant('doctorate') }
          ],
          fieldName: 'education',
          selectMultipleAllowed: false,
          previousPage: 'work',
          nextPage: 'height',
          validator: null,
          greySection: false,
          firstSetup: false,
          unselectable: true,
          nopadding: true,
        };

        this.openModalsRenewed(educationInfo.fieldName, educationInfo.nextPage, educationInfo.previousPage, educationInfo, true, 'choice');
        break;

      case 'height':
        const heightInfo: DefaultPageInterface = {
          fieldName: 'height',
          previousPage: 'education',
          nextPage: 'exercise'
        }

        this.openModalsRenewed(heightInfo.fieldName, heightInfo.nextPage, heightInfo.previousPage, null, false, '');
        break;

      case 'exercise':
        const exerciseInfo: GenericChoiceInterface = {
          logoURL: '/assets/imgs/custom-svg/padronized-sizes/physicalExercise.svg',
          text: this.translate.instant('doYouExercise'),
          options: [{ value: 'never', label: this.translate.instant('never') },
          { value: 'always', label: this.translate.instant('always') },
          { value: 'almostNever', label: this.translate.instant('almostNever') }],
          fieldName: 'exercise',
          selectMultipleAllowed: false,
          previousPage: 'height',
          nextPage: 'lookingFor',
          validator: null,
          greySection: false,
          firstSetup: false,
          unselectable: true,
          nopadding: true,
        };

        this.openModalsRenewed(exerciseInfo.fieldName, exerciseInfo.nextPage, exerciseInfo.previousPage, exerciseInfo, true, 'choice');
        break;

      case 'lookingFor':
        const lookingForInfo: DefaultPageInterface = {
          fieldName: 'lookingFor',
          previousPage: 'exercise',
          nextPage: 'children'
        }

        this.openModalsRenewed(lookingForInfo.fieldName, lookingForInfo.nextPage, lookingForInfo.previousPage, null, false, '');

        break;

      case 'children':
        const childrenInfo: GenericChoiceInterface = {
          logoURL: '/assets/imgs/custom-svg/padronized-sizes/children.svg',
          text: this.translate.instant('wantChildren'),
          options: [{ value: 'yes', label: this.translate.instant('yes') },
          { value: 'maybeSomeday', label: this.translate.instant('maybeSomeday') },
          { value: 'no', label: this.translate.instant('no') },
          { value: 'alreadyHave', label: this.translate.instant('alreadyHave') }],
          fieldName: 'children',
          selectMultipleAllowed: false,
          previousPage: 'lookingFor',
          nextPage: 'astroSign',
          validator: null,
          greySection: false,
          firstSetup: false,
          unselectable: true,
          nopadding: true,
        };

        this.openModalsRenewed(childrenInfo.fieldName, childrenInfo.nextPage, childrenInfo.previousPage, childrenInfo, true, 'choice');
        break;

      case 'astroSign':
        const astroSignInfo: GenericInputInterface = {
          logoURL: '/assets/imgs/custom-svg/padronized-sizes/astrology.svg',
          text: this.translate.instant('whatIsYourSign'),
          valuePlaceHolder: this.translate.instant('yourSign'),
          fieldName: 'astrologySign',
          previousPage: 'children',
          nextPage: 'religion',
          validator: Validators.compose([Validators.maxLength(30)]),
          maxLength: 30,
          firstSetup: false,
          nopadding: true,
        };

        this.openModalsRenewed(astroSignInfo.fieldName, astroSignInfo.nextPage, astroSignInfo.previousPage, astroSignInfo, true, 'input')
        break;

      case 'religion':
        const religionInfo: GenericInputInterface = {
          logoURL: '/assets/imgs/custom-svg/padronized-sizes/religion.svg',
          text: this.translate.instant('isReligious'),
          valuePlaceHolder: this.translate.instant('yourReligion'),
          fieldName: 'religion',
          previousPage: 'astroSign',
          nextPage: 'politics',
          validator: Validators.compose([Validators.maxLength(30)]),
          maxLength: 30,
          firstSetup: false,
          nopadding: true,
        };

        this.openModalsRenewed(religionInfo.fieldName, religionInfo.nextPage, religionInfo.previousPage, religionInfo, true, 'input');
        break;

      case 'politics':
        const politicsInfo: GenericInputInterface = {
          logoURL: '/assets/imgs/custom-svg/padronized-sizes/politics.svg',
          text: this.translate.instant('isPolitical'),
          valuePlaceHolder: this.translate.instant('yourPolitics'),
          fieldName: 'politics',
          previousPage: 'religion',
          nextPage: 'pets',
          validator: Validators.compose([Validators.maxLength(30)]),
          maxLength: 30,
          firstSetup: false,
          nopadding: true,
        };

        this.openModalsRenewed(politicsInfo.fieldName, politicsInfo.nextPage, politicsInfo.previousPage, politicsInfo, true, 'input');
        break;

      case 'pets':
        const petsInfo: GenericInputInterface = {
          logoURL: '/assets/imgs/custom-svg/padronized-sizes/animal_new.svg',
          text: this.translate.instant('hasPets'),
          valuePlaceHolder: this.translate.instant('yourPets'),
          fieldName: 'pets',
          previousPage: 'politics',
          nextPage: 'willingToHelp',
          validator: Validators.compose([Validators.maxLength(30)]),
          maxLength: 30,
          firstSetup: false,
          nopadding: true,
        };

        this.openModalsRenewed(petsInfo.fieldName, petsInfo.nextPage, petsInfo.previousPage, petsInfo, true, 'input');
        break;

      case 'distanceUnits':
        const distanceUnitsInfo: GenericChoiceInterface = {
          logoURL: '/assets/imgs/custom-svg/padronized-sizes/distance.svg',
          text: this.translate.instant('distanceUnitSelection'),
          options: [{ value: 'km', label: this.translate.instant('km') },
          { value: 'mi', label: this.translate.instant('mi') }
          ],
          fieldName: 'distanceUnit',
          selectMultipleAllowed: false,
          previousPage: 'willingToHelp',
          nextPage: 'language',
          validator: null,
          greySection: true,
          firstSetup: false,
          unselectable: false,
          showBackgroundCircle: true,
        };

        this.openModalsRenewed(distanceUnitsInfo.fieldName, distanceUnitsInfo.nextPage, distanceUnitsInfo.previousPage, distanceUnitsInfo, true, 'choice');
        break;

      case 'language':
        const languageInfo: GenericChoiceInterface = {
          logoURL: '/assets/imgs/custom-svg/padronized-sizes/language.svg',
          text: this.translate.instant('languageSelection'),
          options: [{ value: 'en', label: this.translate.instant('en') },
          { value: 'pt', label: this.translate.instant('pt') },
          { value: 'es', label: this.translate.instant('es') },
          { value: 'de', label: this.translate.instant('de') },
          { value: 'fr', label: this.translate.instant('fr') },
          { value: 'it', label: this.translate.instant('it') },
          { value: 'da', label: this.translate.instant('da') },
          { value: 'pl', label: this.translate.instant('pl') },
          { value: 'ko', label: this.translate.instant('ko') }
          ],
          fieldName: 'language',
          selectMultipleAllowed: false,
          previousPage: 'distanceUnits',
          nextPage: null,
          validator: null,
          greySection: true,
          firstSetup: false,
          unselectable: false,
          showBackgroundCircle: true,
        };

        this.openModalsRenewed(languageInfo.fieldName, languageInfo.nextPage, languageInfo.previousPage, languageInfo, true, 'choice');
        break;
    }
  }

  async openModalsRenewed(pageName: string, nextPage: string, pastPage: string | null, pageInfo: any, isGeneric: boolean, genericType: string) {

    this.setActiveFocus(false);

    console.log(pageInfo);
    //alert(JSON.stringify(pageInfo));
    //opens modal
    const modal = this.setModals(pageName, isGeneric, genericType, pageInfo);




    if (modal) {
      (await modal).onDidDismiss().then((val) => {

        if (val != null) {
          val = val.data;
          switch (pageName) {
            //modals that don't have a previous page
            case 'diet':
              this.dismissNoPreviousPage(nextPage, val);
              break;

            case 'activism':
              this.dismissNoPreviousPage(nextPage, val);
              break;

            //modals that don't have a next page
            case 'city':
              this.dismissNoNextPage(pastPage, val);
              Preferences.set({ key: 'USER_FIRST_SETUP', value: 'true' }).then((_val) => {
                console.log("userFirstSetup saved to DB");
              })

              this.save()
              break;

            case 'language':
              this.dismissNoNextPage(pastPage, val);
              break;

            //the rest
            default:
              this.dismissDefaultPage(nextPage, pastPage, val);
              break;
          }
        } else {
          this.dismissDefaultPage(nextPage, pastPage, val);
        }

      });


    }
    this.setChanged();
    if (modal) {
      (await modal).present();
    }

  }

  interestOptions() {
    this.userData?.hasOwnProperty('interest2')
    if (this.userData != null && this.userData.hasOwnProperty('interest2')) {
      if (this.userData.interest2 != null) {
        const interestsChosen: any[] = [];

        this.userData.interest2.forEach((interest: string) => {
          if (interest == 'female') {
            interestsChosen.push(this.translate.instant('women'));
          } else if (interest == 'male') {
            interestsChosen.push(this.translate.instant('men'));
          } else if (interest == 'other') {
            interestsChosen.push(this.translate.instant('nonBinaryGenderDiverse'));
          }
        });
        // this.alertCtrl.dismiss();
        return interestsChosen.join(", ");
      } else {
        return "";
      }
    } else {
      return "";
    }

  }

  dismissNoPreviousPage(nextPage: string, data: any) {
    // console.log(nextPage +this.isFirstSetup + this.userData.diet);
    if (nextPage == 'gender' && this.isFirstSetup && this.userData.diet) {
      if (this.userData.diet == 'vegan') {
        this.setPageInfo('willingToHelp');
      } else {
        this.setPageInfo('lookingForHelp');
      }
    } else if (data == 'nextModal') {
      this.setPageInfo(nextPage);

    } else if (data == 'backModal' || data == 'exitModal') {
      this.setActiveFocus(true);

    } else {
      this.setActiveFocus(true);
    }
  }

  dismissNoNextPage(previousPage: string | null, data: any) {
    if (data == 'backModal') {
      this.setPageInfo(previousPage);

    }
    else if (data == 'exitModal' || data == 'nextModal') {
      this.setActiveFocus(true);

    } else {
      this.setActiveFocus(true);
    }
  }

  dismissDefaultPage(nextPage: string, previousPage: string | null, data: any) {
    if (previousPage == 'diet' && nextPage == 'gender' && !this.isFirstSetup) {
      previousPage = 'pets'
      nextPage = 'distanceUnits';
    }

    if (data == 'nextModal') {
      if (nextPage == 'willingToHelp' && this.userData.diet) {
        if (this.userData.diet == 'vegan') {
          this.setPageInfo('willingToHelp');
        } else {
          this.setPageInfo('lookingForHelp');
        }
      } else {
        this.setPageInfo(nextPage);
      }
    } else if (data == 'backModal') {
      if ((previousPage == 'willingToHelp' || previousPage == 'diet' && nextPage == 'interest' && this.isFirstSetup) && this.userData.diet) {
        if (this.userData.diet == 'vegan') {
          this.setPageInfo('willingToHelp');
        } else {
          this.setPageInfo('lookingForHelp');
        }
      } else {
        this.setPageInfo(previousPage);
      }
    } else {
      this.setActiveFocus(true);

      //if(nextPage == 'interest'){
      //alert("gender desc fora: "+this.userData.genderdescription);
      //}
    }
  }

  openDietSince() {
    //document.getElementById('dietSinceDate').click();
    this.openDatePicker = !this.openDatePicker;
  }

  formatDietSince() {
    const formatedDate: string[] = ['', ''];

    const splittedDate: string[] = this.userData.since.split('-'); // [YYYY, MM, DD]

    const defaultFormat: string = this.translate.instant('dateFormat'); // Tipo 'MM/YYYY' ou 'YYYY/MM'
    const separator: string = defaultFormat.includes('/') ? '/' : '.';

    const defaultFormatSplit: string[] = defaultFormat.split(separator);

    let index = 0;
    for (let i = 0; i < defaultFormatSplit.length; i++) {
      switch (defaultFormatSplit[i]) {
        case 'YYYY':
          formatedDate[index++] = splittedDate[0];
          break;
        case 'MM':
        case 'MMM': // Se precisar tratar mês abreviado também
          formatedDate[index++] = splittedDate[1];
          break;
        // Ignora dia (DD ou DDD)
      }
    }

    return formatedDate.join(separator);
  }


  ionViewWillEnter() {
    // O voltar NATIVO (botao do Android, gesto do iOS) nao passava pelo `back()`: fechava o
    // editor e jogava a edicao fora sem perguntar — justamente o que a confirmacao do X
    // existe para evitar. Prioridade 101 para rodar ANTES do handler padrao, que e 100 no
    // resto do app.
    this.soltarVoltarNativo?.unsubscribe();
    this.soltarVoltarNativo = this.platform.backButton.subscribeWithPriority(101, async () => {
      if (!this.showCropper) {
        return; // fora do editor, vale o comportamento padrao da pagina
      }
      if (this.folhaAberta) {
        this.cancelarFolha(); // com folha aberta, voltar fecha a FOLHA, nao o editor
        return;
      }
      await this.back();
    });

    console.log('ionViewWillEnter ProfilePage');
    const limitDate = new Date();
    const month = limitDate.getMonth() + 1;// PgetMonth is zero based
    const day = limitDate.getDate();
    this.today = limitDate.getFullYear() + '-' + (month < 10 ? '0' : '') + month + '-' + (day < 10 ? '0' : '') + day;
    console.log('today: ' + this.today);

    Preferences.get({ key: 'USER_DATA' }).then(async (val: any) => {

      if (val === null) {
        this.goToLoginPage();
        return
      } else if ((JSON.parse(val.value)).needsEmailValidation) {
        this.modalCtrl.create({ component: EmailValidationPage });
        return
      }

      this.userData = val.value ? JSON.parse(val.value) : null;

      console.log(this.userData.since);
      this.userIsPremium = this.purchaseServiceProvider.isPremium(this.userData);

      this.loadView(true);
      if (this.userData) {
        this.missingInformation = this.userData.diet == null || this.userData.gender2 == null || this.userData.interest2 == null
          || this.userData.firstName == null || this.userData.age == null || this.userData.city == null;
      }

      this.isFirstSetup = await this.resolveIsFirstSetup(this.userData);
      if (this.isFirstSetup) {
        this.present1CoinOffer();
        //this.present5CoinPromotion();
      } else if (this.missingInformation) {
        this.alertMissingInformation();
      }
    })

  }

  async alertMissingInformation() {
    const alert = this.alertCtrl.create({
      subHeader: this.translate.instant('checkMissingInformation'),
      message: "",
      backdropDismiss: false,
      buttons: [
        {
          text: 'Ok',
          handler: () => {
            this.setPageInfo('diet');
          }
        }
      ]
    });
    (await alert).present();

  }

  goToLoginPage() {
    this.router.navigateByUrl('/login');
  }

  async present1CoinOffer() {
    const fieldsComplete = this.onboardingService.hasRequiredProfileFields(this.userData);
    const alert = this.alertCtrl.create({
      subHeader: this.translate.instant(
        fieldsComplete ? 'completeProfileWinVegglyCoinPicture' : 'completeProfileWinVegglyCoin'
      ),
      message: this.translate.instant(fieldsComplete ? 'completeProfileMsgPicture' : 'completeProfileMsg'),
      backdropDismiss: false,
      buttons: [
        {
          text: 'Ok',
          handler: () => {
            if (fieldsComplete) {
              return;
            }
            if (this.userData?.diet === 'vegan') {
              this.setPageInfo('willingToHelp');
            } else if (this.userData?.diet) {
              this.setPageInfo('lookingForHelp');
            } else {
              this.setPageInfo('diet');
            }
          }
        }
      ],
    });

    (await alert).present();
  }

  setHeight() {

    const heightValueFoot = this.userData.height * 0.0328084 | 0;  //cm -> feet
    const heightValueInch = ((this.userData.height * 0.0328084) - heightValueFoot) * 12 | 0; //feet -> inches

    return ((this.userData.height / 100) + " m / " + heightValueFoot + "'" + heightValueInch);
  }


  lookingForOptions() {
    if (this.userData.lookingFor != null) {
      const optionsChosen: any[] = [];

      this.userData.lookingFor.forEach((option: string | string[]) => {
        optionsChosen.push(this.translate.instant(option));
      });

      return optionsChosen.join(", ");
    } else {
      return "";
    }
  }



  // Shuffling logic

  private buildSortableOptions() {
    return {
      animation: 150,
      forceFallback: true,
      fallbackOnBody: true,
      swapThreshold: 0.65,
      // Allow tiny finger movement during the long-press delay without canceling it.
      touchStartThreshold: 5,
      // Hold to enter reorder; once shuffling, further drags start immediately.
      delay: this.shuffling ? 0 : 250,
      delayOnTouchOnly: false,
      filter: '.close-circle, .logoUserValidated',
      preventOnFilter: false,
      // Fires after the delay while the finger is still down — drag continues seamlessly.
      onChoose: () => {
        this.ngZone.run(() => {
          void this.startShuffle(true);
        });
      },
      onUnchoose: () => {
        this.ngZone.run(() => {
          this.afterReorderGesture();
        });
      },
      onEnd: () => {
        this.ngZone.run(() => {
          this.afterReorderGesture();
        });
      },
    };
  }

  private afterReorderGesture() {
    if (this.shuffling) {
      this.refreshSortableOptions();
    }
    void this.flushPendingReorderValidationWarning();
  }

  private refreshSortableOptions() {
    this.sortablejsOptions = this.buildSortableOptions();
  }

  private pendingReorderValidationWarning = false;

  /**
   * Enter shuffle/reorder mode. When triggered from an active Sortable long-press
   * (`fromActiveDrag`), skip lock resets so we don't tear down the in-progress drag.
   */
  async startShuffle(fromActiveDrag = false) {
    if (this.shuffling) {
      return;
    }
    if (!fromActiveDrag) {
      this.resetReorderInteractionLocks();
    }
    this.shuffling = true;
    this.preShufflePictures = [...this.pictures];
    // Avoid mutating the list / Sortable options mid-gesture — that can cancel the active drag.
    if (!fromActiveDrag) {
      this.refreshSortableOptions();
      this.solveHoles(this.pictures);
    }

    if (this.platform.is('android')) {
      setTimeout(() => this.updateImageDragState(), 50);
    }

    if (this.userData?.userValidated) {
      if (fromActiveDrag) {
        // Defer toast until the finger is up so it doesn't interrupt the drag.
        this.pendingReorderValidationWarning = true;
      } else {
        await this.showReorderValidationWarning();
      }
    }
  }

  private async showReorderValidationWarning() {
    const now = Date.now();
    if (now - this.lastReorderValidationWarningAt < this.reorderValidationWarningCooldownMs) {
      return;
    }
    this.lastReorderValidationWarningAt = now;
    const toast = await this.toastCtrl.create({
      message: this.translate.instant('profilePhotoValidationWarning'),
      duration: 5000,
      position: 'top'
    });
    await toast.present();
  }

  private async flushPendingReorderValidationWarning() {
    if (!this.pendingReorderValidationWarning) {
      return;
    }
    this.pendingReorderValidationWarning = false;
    await this.showReorderValidationWarning();
  }

  async saveOrder() {
    // Reorganizar fotos para as primeiras posições antes de salvar
    this.solveHoles(this.pictures);
    const previousPictures = [...this.preShufflePictures];
    const wasValidated = !!this.userData?.userValidated;
    const didPrimaryPhotoChange = this.hasPrimaryPhotoChangedAfterReorder();
    let forcedUserValidatedState: boolean | null = null;

    await this.savePicturesOnUserData(this.pictures);
    const wasSaved = await this.saveUserData();
    if (!wasSaved) {
      this.pictures = [...previousPictures];
      await this.savePicturesOnUserData(this.pictures, true);
      this.exitShuffleMode();
      return;
    }

    if (wasValidated && didPrimaryPhotoChange) {
      let isPrimaryPhotoValidated = false;
      let validationFailed = false;
      const validationLoader = await this.loadingCtrl.create({
        message: this.translate.instant('pleaseWait'),
      });
      await validationLoader.present();

      try {
        const validationResponse = await firstValueFrom(this.userService.validateProfile(this.userData));
        const validationData = JSON.parse(validationResponse);
        isPrimaryPhotoValidated = validationData?.result === 'ok';
      } catch (err) {
        validationFailed = true;
        this.util.showToastUnableToConnect(this.toastCtrl);
        console.log('Error validating reordered primary photo: ' + JSON.stringify(err));
      } finally {
        await validationLoader.dismiss();
      }

      if (!validationFailed) {
        if (!isPrimaryPhotoValidated) {
          const shouldKeepNewPrimary = await this.confirmUnvalidatedPrimaryPhotoChange();
          if (shouldKeepNewPrimary) {
            this.userData.userValidated = false;
            forcedUserValidatedState = false;
          } else {
            this.pictures = [...previousPictures];
            this.userData.userValidated = true;
            forcedUserValidatedState = true;
            await this.savePicturesOnUserData(this.pictures, true);
            const wasRevertSaved = await this.saveUserData();
            if (!wasRevertSaved) {
              this.util.showToastUnableToConnect(this.toastCtrl);
            }
            await Preferences.set({ key: 'USER_DATA', value: JSON.stringify(this.userData) });
            this.preShufflePictures = [...this.pictures];
            this.exitShuffleMode();
            return;
          }
        } else {
          this.userData.userValidated = true;
          forcedUserValidatedState = true;
        }
      }
    }

    if (forcedUserValidatedState !== null) {
      this.userData.userValidated = forcedUserValidatedState;
      await Preferences.set({ key: 'USER_DATA', value: JSON.stringify(this.userData) });
    }

    this.preShufflePictures = [...this.pictures];

    this.exitShuffleMode();
  }

  private exitShuffleMode() {
    this.shuffling = false;
    this.pendingReorderValidationWarning = false;
    this.refreshSortableOptions();
    this.resetReorderInteractionLocks();
  }

  /**
   * Move to the right all of the itens on the pictures array. Solving holes
   * @param pictures
   */
  solveHoles(pictures: string[]) {
    let availableIndex = 0
    for (let i = 0; i < pictures.length; i++) {
      if (pictures[i] === this.grayPlus) continue;

      if (i !== availableIndex) {
        pictures[availableIndex] = pictures[i];
        pictures[i] = this.grayPlus;
      }

      availableIndex++;
    }
  }

  /**
   * Check for changes on the picture list and save on the userData.
   * @param pictures 
   * @returns 
   */
  async savePicturesOnUserData(pictures: string[], force = false) {
    /* ESTA FUNCAO NAO COMPACTA. Ela so serializa, fielmente, o array que recebe.
    
       Ela chamava `solveHoles(pictures)` aqui, e era a raiz do bug de excluir varias fotos. O
       `/soul/image/delete` faz `$unset`, que deixa BURACO no servidor, e a compactacao local
       so viaja com o header `reorderPictures=true` — que sai de um unico lugar, o
       `saveUserData()`. Compactando aqui, o indice da tela deixava de corresponder ao slot do
       servidor da segunda exclusao em diante.
    
       O `saveOrder()` ja chama `solveHoles` por conta propria, logo antes de chamar esta
       funcao, e e ele que empurra a nova ordem para o servidor. Ou seja: a compactacao segue
       existindo exatamente onde ela e combinada com o servidor, e em nenhum outro lugar. */
    
    // Verificar se houve mudanças
    const hasChanges = !this.hasSamePictureOrder(pictures, this.preShufflePictures);
    
    if (!force && !hasChanges) {
      console.log("No changes on pictures order");
      return;
    }

    // Save the order on the userData
    for (let i = 0; i < pictures.length; i++) {
      if (pictures[i] == this.grayPlus) {
        this.userData['picture' + i] = null;
      }
      else {
        const pic_id = this.getPictureIdFromUrl(pictures[i]);
        if (!pic_id) {
          continue;
        }
        this.userData['picture' + i] = { '$oid': pic_id };
      }
    }

    try {
      await Preferences.set({ key: 'USER_DATA', value: JSON.stringify(this.userData) });
    } catch (error) {
      console.error('Error storing images: ', JSON.stringify(error, Object.getOwnPropertyNames(error)));
    }
  }

  async saveUserData(): Promise<boolean> {
    const loader = await this.loadingCtrl.create({
      message: this.translate.instant('pleaseWait'),
    });
    await loader.present();

    try {
      const locationValue = await Preferences.get({ key: 'LAST_LOCATION' });
      let location = locationValue.value ? JSON.parse(locationValue.value) : null;
      const teleportationLocation = this.locationSvc.getTeleportationLocation();
      if (teleportationLocation != null) {
        location = teleportationLocation;
      }

      const fcmToken = await Preferences.get({ key: 'TOKEN' });
      if (fcmToken && fcmToken.value) {
        this.userData.token = fcmToken.value;
      } else {
        const localToken = localStorage.getItem('TOKEN');
        if (localToken) {
          this.userData.token = localToken;
        }
      }

      console.log('this.userData before upsert on saveUserData: ' + JSON.stringify(this.userData));
      const data = await firstValueFrom(
        this.userService.upsertSoul(this.userData, location, false, true /*reorderPictures*/, false)
      );
      console.log('profile - upsert subscribe entered');
      console.log(JSON.stringify(data));

      if (data != '{not ok}') {
        const userData = JSON.parse(data);
        this.userData = userData;
        console.log('userData after upsert: ' + JSON.stringify(this.userData));
        await Preferences.set({ key: 'USER_DATA', value: JSON.stringify(userData) });
      }

      return true;
    } catch (err) {
      this.util.showToastUnableToConnect(this.toastCtrl);
      console.log('Error: ' + JSON.stringify(err));
      return false;
    } finally {
      await loader.dismiss();
    }
  }

  private hasSamePictureOrder(first: string[], second: string[]): boolean {
    if (first.length !== second.length) {
      return false;
    }
    return first.every((picture, index) => picture === second[index]);
  }

  private getPictureIdFromUrl(picture: string): string | null {
    if (!picture || picture === this.grayPlus) {
      return null;
    }

    const imageFilesMatch = picture.match(/\/image\.files\/([^\/?#]+)\//);
    if (imageFilesMatch?.[1]) {
      return imageFilesMatch[1];
    }

    const soulImageMatch = picture.match(/\/soul\/image\/([^\/?#]+)/);
    if (soulImageMatch?.[1]) {
      return soulImageMatch[1];
    }

    const parts = picture.split('/').filter(Boolean);
    return parts.length >= 2 ? parts[parts.length - 2] : null;
  }

  private hasPrimaryPhotoChangedAfterReorder(): boolean {
    const before = this.getPictureIdFromUrl(this.preShufflePictures[0]);
    const after = this.getPictureIdFromUrl(this.pictures[0]);
    return before !== after;
  }

  private async confirmUnvalidatedPrimaryPhotoChange(): Promise<boolean> {
    const alert = await this.alertCtrl.create({
      message: this.translate.instant('photoNotValidated'),
      buttons: [
        {
          text: this.translate.instant('save'),
          role: 'confirm'
        },
        {
          text: this.translate.instant('cancel'),
          role: 'cancel'
        }
      ],
    });
    await alert.present();
    const result = await alert.onDidDismiss();
    return result.role === 'confirm';
  }

  private resetReorderInteractionLocks() {
    const docEl = document.documentElement as HTMLElement;
    const body = document.body as HTMLElement;

    [docEl, body].forEach((element) => {
      if (!element) {
        return;
      }
      element.style.touchAction = '';
      element.style.pointerEvents = '';
      element.style.userSelect = '';
      (element.style as any).webkitUserSelect = '';
      (element.style as any).webkitTouchCallout = '';
      element.style.overflow = '';
    });

    const staleSortableElements = document.querySelectorAll(
      '.sortable-fallback, .sortable-ghost, .sortable-chosen, .sortable-drag'
    );
    staleSortableElements.forEach((element) => {
      if (element?.parentNode) {
        element.parentNode.removeChild(element);
      }
    });

    if (this.platform.is('android')) {
      setTimeout(() => {
        this.updateImageDragState();
      }, 50);
    }
  }


  private createFileName(index: number) {
    return 'picture' + index + '.jpg';
  }

  private async persistReplacedPrimaryPicture(pictureID: string): Promise<void> {
    this.userData.picture0 = { '$oid': pictureID };
    this.pictures[0] = this.userService.getImageURL(pictureID);
    await Preferences.set({ key: 'USER_DATA', value: JSON.stringify(this.userData) });
  }

  /**
   * Descarta a foto que esta no editor.
   *
   * Com uma leva de varias, descartar UMA nao aborta as outras — segue para a proxima, como
   * no WhatsApp. So fecha o editor quando a fila esvazia.
   */
  /**
   * Fecha o editor.
   *
   * CONFIRMA antes, e so quando ha algo a perder: edicao em andamento (filtro, ajuste,
   * rotacao, zoom) ou fotos da leva ainda nao enviadas. Sem o guard, um toque no X — que
   * fica no canto, onde o polegar encosta — jogava fora a edicao inteira sem aviso.
   *
   * Nao confirma quando nada foi mexido: perguntar "descartar?" para quem nao editou nada e
   * ruido, e ensina o usuario a confirmar no automatico.
   */
  async back(): Promise<void> {
    if (!this.temEdicaoParaPerder()) {
      this.fecharEditor();
      return;
    }

    const alerta = await this.alertCtrl.create({
      subHeader: this.translate.instant('discardEditsQuestion'),
      buttons: [
        { text: this.translate.instant('cancel'), role: 'cancel' },
        {
          text: this.translate.instant('discard'),
          role: 'destructive',
          handler: () => { this.fecharEditor(); },
        },
      ],
    });
    await alerta.present();
  }

  /** Ha edicao em andamento ou foto da leva ainda nao enviada? */
  private temEdicaoParaPerder(): boolean {
    if (this.selecaoDeFotos.length > 0) {
      return true;
    }
    if (this.activeFilter && this.activeFilter !== 'none') {
      return true;
    }
    if (this.adj.bright !== 1 || this.adj.contrast !== 1 || this.adj.sat !== 1 || this.adj.warm !== 0) {
      return true;
    }
    return this.straightenVal !== 0 || this.zoomVal !== 1 || this.baseRotation !== 0;
  }

  private fecharEditor(): void {
    this.limparSelecaoDeFotos();
    this.folhaAberta = null;
    this.showCropper = false;
    this.soltarCromoDoEditor();
  }

  /**
   * Envia UMA foto para UM slot e persiste o que voltou. Devolve false se falhou.
   *
   * Existe separado do `uploadDirectlyFromBrowser` porque a leva precisa ESPERAR cada envio
   * para seguir ao proximo. O caminho anterior era um `subscribe` que continuava o fluxo de
   * dentro do callback: nao havia como um laco esperar por ele, e foi por isso que o "salvar
   * tudo" nasceu encadeado por evento — o desenho que falhava.
   */
  private async enviarFotoParaSlot(imagemB64: string, slot: number): Promise<boolean> {
    const filename: string = 'picture' + slot;
    try {
      const idDaFoto = await firstValueFrom(
        this.userService.uploadImage64(imagemB64, this.userData, filename)
      );
      this.analytics.registerEvent(AnalyticsService.signUpComplete, true);
      this.analytics.registerEvent(AnalyticsService.loginOrSignUpCompl, true);
      this.userData[filename] = { '$oid': idDaFoto };
      await Preferences.set({ key: 'USER_DATA', value: JSON.stringify(this.userData) });
      this.pictures[slot] = this.userService.getImageURL(idDaFoto);
      return true;
    } catch (erro) {
      console.log('uploadImage error: ' + JSON.stringify(erro));
      return false;
    }
  }

  private async uploadDirectlyFromBrowser(localFile: string, index: number) {
    const loader = await this.loadingCtrl.create({
      message: this.translate.instant('savingPleaseWait'),
    });
    await loader.present();

    const enviou = await this.enviarFotoParaSlot(localFile, index);
    await loader.dismiss();

    if (!enviou) {
      this.util.showToastUnableToConnect(this.toastCtrl);
      this.showCropper = false;
      return;
    }

    // Esta foto acabou. Se a leva tinha mais, o editor reabre com a proxima; senao
    // fecha, como antes.
    const temProxima = await this.concluirFotoDaSelecao();
    if (!temProxima) {
      this.showCropper = false;
    }
  }

  /**
   * Os slots que vao receber esta leva: do que o usuario tocou para a frente, em SEQUENCIA,
   * SUBSTITUINDO o que estiver em cada um.
   *
   * Antes so slots VAZIOS entravam na conta, e um perfil cheio devolvia "nao ha espaco livre"
   * e salvava uma foto so — foi o que o usuario reportou. Tocar num slot ocupado sempre
   * significou "trocar esta foto"; a leva apenas continua essa intencao nas posicoes
   * seguintes. Quem toca no slot 4 com nove fotos e escolhe quatro quer as posicoes 4 a 7
   * trocadas, e nao uma mensagem de erro.
   *
   * NAO da a volta para o inicio ao chegar no fim da grade. Voltar ao slot 0 passaria por
   * cima da foto PRINCIPAL sem o usuario ter tocado nela, e trocar a principal custa o selo
   * de verificacao dele — caro demais para acontecer por sobra de leva.
   *
   * Decidir TODOS de uma vez, e nao slot-a-slot durante o envio, e o que garante que duas
   * fotos nao caiam no mesmo lugar — era esse o segundo motivo de so uma sobreviver.
   */
  private slotsDaLeva(quantasFotos: number): number[] {
    const primeiro = this.posicaoValida(this.slotInicial);
    const slots: number[] = [primeiro];
    this.pictures.forEach((foto, i) => {
      if (i !== primeiro && this.slotVazio(foto)) {
        slots.push(i);
      }
    });
    return slots.slice(0, quantasFotos);
  }

  /** Carrega a foto no cropper, aplica a edicao dela e devolve o JPEG final. */
  private async exportarItemDaLeva(
    item: { foto: Photo; thumb: string; edicao?: EdicaoDaFoto }
  ): Promise<string | null> {
    const indice = this.selecaoDeFotos.indexOf(item);
    if (indice < 0) {
      return null;
    }

    // A foto que ja esta em tela nao precisa ser recarregada; as outras entram agora, e a
    // edicao de cada uma e restaurada pelo `onCropperReady`.
    if (this.editandoNaSelecao !== indice) {
      await this.carregarItemNoCropper(indice);
      await this.aguardarCropperPronto();
    }

    // Foto que o usuario nunca abriu entra com o recorte centralizado — o mesmo que ele veria
    // se tivesse aberto. Chamado aqui, e nao pelos timers do `onCropperReady`, porque aqueles
    // rodariam DEPOIS do export.
    if (!item.edicao) {
      this.centralizarRecorteNaImagem();
    }

    try {
      // Piso no export, substituindo o `minCroppedWidth` morto que vivia nas opcoes.
      //
      // SEM teto, de proposito. Um `maxWidth/maxHeight` aqui parece proteger do limite de area
      // de canvas do WebKit, mas no cropperjs 1.6.2 o MESMO par de chaves limita a FONTE
      // (`getSourceCanvas`) e a saida: medido, a foto salva saia 25-40% menor de cada lado e
      // nunca chegava ao teto pedido. Encolher a foto de todo usuario para cobrir um risco que
      // nunca foi reproduzido e um negocio ruim. O teto por AREA, que seria o limite de
      // verdade, fica como tarefa propria.
      const canvas = (this.angularCropper?.cropper as any)?.getCroppedCanvas({ minWidth: 320, minHeight: 400, imageSmoothingQuality: 'high' });
      if (!canvas || canvas.width === 0) {
        return null;
      }
      return this.bakeFilter(canvas).toDataURL('image/jpeg', 1.0);
    } catch {
      return null;
    }
  }

  /**
   * Salva a leva inteira num toque. E o que o botao Salvar chama.
   *
   * Percorre as fotos num LACO e espera cada etapa: carrega no cropper, espera ficar pronto,
   * exporta, envia. A versao anterior encadeava pelo evento `ready` — ligava uma bandeira e
   * cada `ready` disparava o salvamento seguinte — e arrebentava de duas maneiras:
   *
   *  - a foto que caia no slot 0 entra no fluxo de validacao da principal, que sai por
   *    `return` sem passar pelo upload; a corrente parava ali, com uma foto salva de quatro;
   *  - o `ready` do angular-cropperjs chega REPETIDO (a lib acumula listeners a cada troca de
   *    imagem), entao a mesma foto podia ser exportada e enviada duas vezes.
   *
   * Um laco com `await` nao tem nenhum dos dois problemas, e a principal sai POR ULTIMO: o
   * modal de validacao dela no meio da leva pararia o envio das outras.
   */
  async salvarTudo(): Promise<void> {
    // Uma foto so: caminho de sempre, que ja trata a validacao da principal.
    if (this.selecaoDeFotos.length <= 1) {
      await this.saveCropped();
      return;
    }

    // A foto aberta ainda nao teve a edicao guardada se o usuario nao trocou de miniatura
    // depois de mexer nela.
    this.guardarEdicaoDaFotoAtual();

    // `slotsDaLeva` sempre devolve ao menos um slot, porque o slot tocado existe na grade.
    const slots = this.slotsDaLeva(this.selecaoDeFotos.length);
    const leva = this.selecaoDeFotos
      .slice(0, slots.length)
      .map((item, i) => ({ item, slot: slots[i] }));
    const semEspaco = this.selecaoDeFotos.length - leva.length;
    const principal = leva.find((par) => par.slot === 0) || null;

    const loader = await this.loadingCtrl.create({
      message: this.translate.instant('savingPleaseWait'),
    });
    await loader.present();

    let falhas = 0;
    for (const par of leva) {
      if (par === principal) {
        continue; // vai no fim, pelo caminho de validacao
      }
      const imagem = await this.exportarItemDaLeva(par.item);
      if (!imagem || !(await this.enviarFotoParaSlot(imagem, par.slot))) {
        falhas++;
      }
    }
    await loader.dismiss();
    this.slotInicialUsado = true;

    if (principal) {
      // A principal volta a ser a unica da tira e o `saveCropped` cuida dela como sempre:
      // valida, mostra o resultado e fecha o editor.
      //
      // Recarrega no cropper SO se o laco tirou ela da tela. Recarregar a foto que ja esta
      // ali atribuiria a MESMA url a <img>, e um `load` que nao dispara deixaria a espera
      // rodando ate a rede de seguranca — oito segundos de tela parada sem motivo.
      const jaEstaEmTela = this.selecaoDeFotos[this.editandoNaSelecao] === principal.item;
      this.selecaoDeFotos = [principal.item];
      this.editandoNaSelecao = 0;
      if (!jaEstaEmTela) {
        await this.carregarItemNoCropper(0);
        await this.aguardarCropperPronto();
        // Mesmo motivo de `exportarItemDaLeva`: foto nunca aberta entra com o recorte
        // centralizado agora, e nao pelos timers, que correriam DEPOIS do export.
        if (!principal.item.edicao) {
          this.centralizarRecorteNaImagem();
        }
      }
      this.workingOnIndex = 0;
      await Preferences.set({ key: 'WORKING_ON_INDEX', value: JSON.stringify(0) });
      await this.saveCropped();
      // `saveCropped` devolve o controle com o envio ainda em curso (ele segue por
      // `subscribe`), e os caminhos de validacao nao passam pela tira. Limpar aqui e o que
      // impede a leva ja enviada de continuar "pendente" e pedir confirmacao ao fechar.
      this.limparSelecaoDeFotos();
    } else {
      this.limparSelecaoDeFotos();
      this.showCropper = false;
    }

    if (falhas > 0) {
      this.util.showToastUnableToConnect(this.toastCtrl);
    } else if (semEspaco > 0) {
      // Mensagem propria, e nao "nao ha espaco livre": com a substituicao em sequencia o que
      // acabou nao foi espaco vazio, foi a GRADE — e o que resolve e comecar mais atras.
      this.util.presentToast(
        this.toastCtrl,
        this.translate.instant('photoBatchOverflow', { count: semEspaco }),
        4000
      );
    }
  }

  async saveCropped() {
    const loading = await this.loadingCtrl.create({
      message: this.translate.instant('pleaseWait'),
      spinner: 'crescent', // ou outro estilo de spinner
      duration: 5000 // tempo máximo para o loading (caso necessário)
    });
    await loading.present();


    const cropper = this.angularCropper.cropper;


    // Mesmo piso do `exportarItemDaLeva`, e pelo mesmo motivo sem teto.
    if (cropper && cropper.getCroppedCanvas({ minWidth: 320, minHeight: 400, imageSmoothingQuality: 'high' })) {
      const croppedCanvas = cropper.getCroppedCanvas({ minWidth: 320, minHeight: 400, imageSmoothingQuality: 'high' });

      if (croppedCanvas.width > 0 && croppedCanvas.height > 0) {
        const finalCanvas = this.bakeFilter(croppedCanvas);
        const croppedImgB64String: string = finalCanvas.toDataURL('image/jpeg', 1.0);
        this.croppedImage = croppedImgB64String;
        const img_base64 = this.croppedImage.split(',')[1]
        const result = await Preferences.get({ key: 'WORKING_ON_INDEX' });


        if (Boolean(result.value) == true) {
          this.workingOnIndex = parseInt(result.value?.toString() ?? '');
        }

        if (this.workingOnIndex === 0) {
          // A foto PRINCIPAL tem fluxo proprio de validacao, com modal e caminhos que saem por
          // `return` sem passar pelo upload. Por isso o `salvarTudo` deixa a principal para o
          // FIM da leva: um modal de validacao no meio pararia o envio das outras.

          // A validação só deve acontecer quando há foto no index 0
          // Como estamos salvando uma foto no index 0, vamos permitir a validação

          if (!this.userData?.hasValidPoseSelfie) { // if user is not validated
            // alert("!this.userData.hasValidPoseSelfie")
            await loading.dismiss();
            this.uploadDirectlyFromBrowser(this.croppedImage, this.workingOnIndex);
            return;

          } else if (!this.userData?.userValidated) { // user validated selfies but not profile
            // alert("!this.userData?.userValidated")

            const theObs = this.userService.updateProfilePicture(this.userData, img_base64);

            theObs.subscribe(async response => {
              await loading.dismiss();
              // alert(data)
              const { result, pictureID } = JSON.parse(response)
              if (result === 'notok') {
                const message = this.translate.instant("photoNotValidated");
                this.showMessageAlert(this.croppedImage, this.workingOnIndex, message, false)
                return;
              } else {
                this.userData.userValidated = true;
                await this.persistReplacedPrimaryPicture(pictureID);
                this.showComponentUserValidated();
                return;
              }
            })
            return;
          } else { // user validated selfie and profile
            // alert("this.userData?.userValidated")
            const theObs = this.userService.updateProfilePicture(this.userData, img_base64);

            theObs.subscribe(async response => {
              await loading.dismiss();
              const { result, pictureID } = JSON.parse(response)
              if (result === 'ok') {

                //criar novo componente. Messagem: Foto validada
                this.userData.userValidated = true;
                await this.persistReplacedPrimaryPicture(pictureID);
                this.showComponentNewPhotoValidation();
                return;

              } else {
                this.showComponentNewPhotoNotApproved();
                //mostrar alert: Sua imagem não foi validada. Caso clique em salvar você irá perder o selo de verificação da conta
                // let message = "Sua imagem não foi validada. Caso clique em salvar você irá perder o selo de verificação da conta"
                // this.showMessageAlert(this.croppedImage, this.workingOnIndex, message, true);
                return
              }

            })

            return;
          }
        } else {
          this.uploadDirectlyFromBrowser(this.croppedImage, this.workingOnIndex);
          console.log('workingOnIndex: ' + this.workingOnIndex);
        }
      }
    } else {
      this.util.presentToast(this.toastCtrl, this.translate.instant('failUploadImage'), 5000);
      this.showCropper = false;
    }


  }


  async showComponentUserValidated() {
    // Verificar se há foto no index 0 e se o usuário está realmente validado
    const hasPhotoAtIndex0 = this.pictures[0] && this.pictures[0] !== this.grayPlus;
    const isUserValidated = this.userData?.userValidated === true;
    
    // Só mostrar o modal se houver foto no index 0 e o usuário estiver validado
    if (!hasPhotoAtIndex0 || !isUserValidated) {
      console.log('Não há foto no index 0 ou usuário não está validado, modal não será exibido');
      return;
    }
    
    document.documentElement.style.overflow = 'hidden';
    document.body.style.overflow = 'hidden';
    const modal = await this.modalCtrl.create({
      component: ValidationCompletedComponent,
      componentProps: {
        me: this.userData
      },
      cssClass: 'custom-class-modal',
      backdropDismiss: true
    });
    modal.present();

    modal.onDidDismiss().then(async (_val) => {
      this.refreshPage()
    });

    await modal.onDidDismiss();
    document.documentElement.style.overflow = '';
    document.body.style.overflow = '';

  }

  async showComponentNewPhotoValidation() {
    document.documentElement.style.overflow = 'hidden';
    document.body.style.overflow = 'hidden';
    const modal = await this.modalCtrl.create({
      component: NewPhotoValidationComponent,
      componentProps: {
        me: this.userData
      },
      cssClass: 'custom-class-modal',
      backdropDismiss: true
    });

    (await modal).present();

    await modal.onDidDismiss().then((_val) => {
      this.refreshPage()
    });
    await modal.onDidDismiss();
    document.documentElement.style.overflow = '';
    document.body.style.overflow = '';
  }

  async refreshPage() {
    Preferences.set({ key: 'USER_DATA', value: JSON.stringify(this.userData) }).then(async (_val) => {
      console.log("userData saved")
    })
    this.showCropper = false;
    this.modalCtrl.dismiss();
  }

  async showComponentNewPhotoNotApproved() {
    document.documentElement.style.overflow = 'hidden';
    document.body.style.overflow = 'hidden';
    const modal = await this.modalCtrl.create({
      component: NewPhotoNotApprovedComponent,
      componentProps: {
        me: this.userData
      },
      cssClass: 'custom-class-modal',
      backdropDismiss: true
    });

    (await modal).onDidDismiss().then((val) => {

      if (val && val.data === "descart") {
        this.showCropper = false;
        return;
      } else if (val && val.data === "toUse") {
        this.userData.userValidated = false;
        this.uploadDirectlyFromBrowser(this.croppedImage, this.workingOnIndex);
        return;
      }

    });
    (await modal).present();
    await modal.onDidDismiss();
    document.documentElement.style.overflow = '';
    document.body.style.overflow = '';


  }

  async showMessageAlert(croppedImage: any, workingOnIndex: any, message: any, changeUserValidated?: boolean) {
    const alert = await this.alertCtrl.create({
      message: message,
      buttons: [
        {
          text: this.translate.instant('save'),
          role: 'info',
          handler: () => {
            this.uploadDirectlyFromBrowser(this.croppedImage, this.workingOnIndex);

            if (changeUserValidated) {
              this.userData.userValidated = false;
            }
            return;
          }
        },
        {
          text: this.translate.instant('cancel'),
          role: 'cancel',
          handler: () => {
            this.showCropper = false;
            return;
          }
        }
      ],

    });
    (await alert).present();
  }

  public async presentActionSheet(index: number) {

    if (this.userData?.userValidated && index === 0) {

      const toast = this.toastCtrl.create({
        message: this.translate.instant('profilePhotoValidationWarning'),
        duration: 5000,
        position: 'top'
      });

      (await toast).present();

    }

    let arrayButtons = []
    arrayButtons = [
      {
        text: this.translate.instant('selectFromGallery'),
        handler: () => {
          this.index = index;
          this.workingOnIndex = index;
          Preferences.set({ key: 'WORKING_ON_INDEX', value: JSON.stringify(index) });
          this.selectFromDevice(index);
        }
      },
      {
        text: this.translate.instant('delete'),
        role: 'destructive',
        handler: () => {
          console.log('Delete clicked');
          this.deleteFile(index);
        }
      },
      {
        text: this.translate.instant('cancel'),
        role: 'cancel',
        handler: () => {
          console.log('Cancel clicked');
        }
      }
    ]
    const actionSheet = this.actionSheetCtrl.create({
      buttons: arrayButtons
    });
    (await actionSheet).present();

  }

  async selectFromDevice(index: number) {
    // Web (ex.: Safari no iPhone): não existe permissão de galeria — o <input type="file">
    // é o próprio gate. Além disso, aguardar checkPermissions/requestPermissions quebra o
    // "user gesture" e o iOS Safari BLOQUEIA a abertura do seletor (ficava preso no "aguarde").
    // Por isso, na web abrimos direto, sincronamente a partir do gesto.
    if (!this.isNative) {
      this.openGallery(index);
      return;
    }
    const status = await Camera.checkPermissions();
    if (status.photos === 'granted' || status.photos === 'limited') {
      this.openGallery(index);
      return;
    }

    const newStatus = await Camera.requestPermissions();

    if (newStatus.photos === 'granted' || newStatus.photos === 'limited') {
      this.openGallery(index);
    } else {
      this.denyCount++;

      if (this.denyCount >= 2) {
        this.showSettingsModal();
      }
    }

  }

  async showSettingsModal() {
    const alert = await this.alertCtrl.create({
      header: this.translate.instant('permissionNecessary'),
      message: this.translate.instant('permissionGallery'),
      buttons: [
        {
          text: this.translate.instant('cancel'),
          role: 'cancel'
        },
        {
          text: this.translate.instant('settingsTitle'),
          handler: async () => {
            if (Capacitor.getPlatform() === 'ios') {
              this.openSettingsIos()
            } else {
              // No Android, abre a página de configurações do app
              this.openSettingsAndroid()
            }
          }
        }
      ]
    });

    await alert.present();
  }

  openSettingsAndroid() {
    NativeSettings.openAndroid({
      option: AndroidSettings.ApplicationDetails,
    });
  }

  openSettingsIos() {
    NativeSettings.openIOS({
      option: IOSSettings.App,
    });

  }


  openGallery(index: any) {
    this.workingOnIndex = index;
    Preferences.set({ key: 'WORKING_ON_INDEX', value: JSON.stringify(this.workingOnIndex) });

    const _pictureName = 'picture' + index + '.jpg';

    const options = {
      quality: 100,
      allowEditing: false,
      resultType: CameraResultType.Uri,
      width: 1200,
      height: 1200,
      source: CameraSource.Photos,
      // O proprio seletor do sistema para no que CABE. Ver `limiteDeFotosDaGaleria`.
      limit: this.limiteDeFotosDaGaleria(index)
    }
    this.getImageFromDevice(index, options);
  }


  /**
   * Quantas fotos o seletor do sistema deixa escolher.
   *
   * Perfil com espaco: o numero de slots vazios. Perfil CHEIO: uma — ali escolher uma foto
   * significa trocar a que foi tocada, e oferecer varias so levaria a substituir fotos que o
   * usuario nao pediu para trocar.
   *
   * O teto por POSICAO entra por cima dos dois: a leva entra a partir do slot tocado, em
   * sequencia, entao de `indiceTocado` em diante existem `pictures.length - indiceTocado`
   * lugares. Sem esse teto, quem tem slots vazios no inicio e toca no ULTIMO ainda conseguiria
   * escolher varias e perder o excesso num aviso. Nos casos comuns os dois numeros coincidem:
   * perfil vazio tocando no primeiro slot da 9, perfil com 4 fotos tocando no primeiro vazio
   * da 5. O teto so age no caso torto, e e ele que torna o aviso de sobra inalcancavel pelo
   * seletor.
   *
   * O vazio e testado contra `this.grayPlus` E contra o getter `PicturesPage.grayPlus`: o
   * getter devolve um asset diferente em tema escuro, e `this.grayPlus` e uma copia feita na
   * criacao do componente — se o tema virar no meio da sessao, os dois valores convivem dentro
   * de `pictures`.
   */
  private limiteDeFotosDaGaleria(indiceTocado: number): number {
    const posicao = this.posicaoValida(indiceTocado);
    const livres = this.pictures.filter((foto) => this.slotVazio(foto)).length;

    // +1 quando o slot tocado JA TEM foto: tocar nele e pedir para trocar aquela, entao ele
    // conta como capacidade junto com os vazios. Perfil cheio tocando numa foto da 0 + 1 = 1;
    // perfil com 4 fotos tocando numa delas da 5 + 1 = 6.
    const capacidade = livres + (this.slotVazio(this.pictures[posicao]) ? 0 : 1);
    return Math.max(1, capacidade);
  }

  /** Um slot esta vazio quando mostra o placeholder, e nao uma foto. */
  private slotVazio(foto: string): boolean {
    // Compara com a copia E com o getter: `PicturesPage.grayPlus` devolve um asset diferente
    // em tema escuro, e `this.grayPlus` e uma copia feita na criacao do componente — se o tema
    // virar no meio da sessao, os dois valores convivem dentro de `pictures`.
    return foto === this.grayPlus || foto === PicturesPage.grayPlus;
  }

  private posicaoValida(indice: number): number {
    return Math.max(0, Math.min(Number(indice) || 0, this.pictures.length - 1));
  }

  private getImageFromDevice(index: number, options: any) {
    //alert('platforms: ' + this.platform.platforms());
    console.log('platforms: ' + this.platform.platforms());
    console.log('this.isNative: ' + this.isNative);

    if (this.isNative) {
      Camera.checkPermissions().then(async (hasIt) => {
        console.log('pictures - hasReadPermission: ' + hasIt.photos);
        if (hasIt.photos != 'granted' && hasIt.photos != 'limited') {
          if (this.platform.is('android')) {
            console.log('pictures - is android');
            const message = this.translate.instant('pleaseAuthorizePicturesAccess');
            this.util.showModalAlertRequestPermission(message, AndroidSettings.ApplicationDetails, IOSSettings.App)
            // this.showModalAlert(this.translate.instant('pleaseAuthorizePicturesAccess'));
            await Camera.requestPermissions().then().catch((err) => {
              console.error('pictures - getImageFromDevice: ' + JSON.stringify(err));
            });
          } else {
            console.log('pictures - is NOT android');
            await Camera.requestPermissions().then((data) => {
              console.log('pictures - requestReadPermission success: ' + JSON.stringify(data));

              this.readFromDisk(options, index);
            }).catch((err) => {
              const message = this.translate.instant('pleaseAuthorizePicturesAccessOnSettings');
              this.util.showModalAlertRequestPermission(message, AndroidSettings.ApplicationDetails, IOSSettings.App)
              // this.showModalAlert(this.translate.instant('pleaseAuthorizePicturesAccessOnSettings'));

              console.error('pictures - requestReadPermission: ' + JSON.stringify(err));
            })
          }
          return;
        } else {
          this.readFromDisk(options, index);
        }
      })


    } else {
      // If it's browser, read directly
      this.readFromDisk(options, index);
    }

    //    }

  }

  /* ---- Seleção de várias fotos: miniaturas + editar na ordem que o usuário quiser -----

     O `Camera.pickImages` sempre devolveu um ARRAY, e o editor (crop + filtros) sempre
     existiu. O que faltava era o que fazer com a 2a foto em diante: o laço que varria
     `results.photos` terminava com `return` depois da PRIMEIRA, e as demais eram descartadas
     EM SILÊNCIO.

     A primeira tentativa foi uma FILA que forçava a ordem e reservava os slots livres de
     antemão. Isso trazia dois problemas: avisava "só há N espaços livres" já na seleção —
     mensagem que o próprio usuário achou confusa — e tirava dele a escolha de qual foto
     editar. Agora é uma TIRA DE MINIATURAS: toca na que quiser, edita, confirma, e a
     miniatura some. O slot de destino é decidido no upload, não na seleção. */

  /**
   * Fotos desta leva que ainda nao foram enviadas, com miniatura e com a EDICAO de cada uma.
   *
   * A edicao viaja junto da foto porque `resetEditorState()` zera filtro, zoom, rotacao e
   * ajustes a cada troca — e o recorte se perdia junto, porque trocar a imagem refaz a caixa
   * do cropperjs. Resultado: marcar a area na foto 1, ir na 2 e voltar jogava o trabalho
   * fora. Agora a edicao e salva ao SAIR de uma foto e restaurada ao VOLTAR nela.
   */
  public selecaoDeFotos: { foto: Photo; thumb: string; edicao?: EdicaoDaFoto }[] = [];

  /** Qual item da seleção está no editor agora. -1 = nenhum. */
  public editandoNaSelecao: number = -1;

  /** Slot que o usuário tocou para abrir a galeria; vale para a primeira foto confirmada. */
  private slotInicial: number = 0;
  private slotInicialUsado: boolean = false;

  /**
   * Guarda a leva escolhida e abre a primeira no editor.
   *
   * A miniatura usa `webPath` direto, sem converter: `readAsBase64` roda só na foto que está
   * sendo editada. Converter a leva inteira de antemão é candidato a estouro de memória em
   * Android antigo, com fotos de câmera moderna.
   */
  private async prepararSelecaoDeFotos(fotos: Photo[], slotTocado: number): Promise<boolean> {
    if (!fotos || fotos.length === 0) {
      return false;
    }

    this.slotInicial = slotTocado;
    this.slotInicialUsado = false;
    this.selecaoDeFotos = fotos.map((foto) => ({ foto, thumb: foto.webPath || '' }));

    // O editor ABRE AGORA, antes de ler o arquivo. Era aqui que nascia a demora de ~2s ao
    // voltar da galeria: `showCropper` so virava true depois do `readAsBase64`, então o
    // usuario voltava para a TELA DE PERFIL e ficava olhando ela enquanto a foto era lida.
    // Abrindo primeiro, ele vê o editor com o indicador de carga desde o primeiro quadro.
    this.showCropper = true;
    this.aguardandoCropper = true;

    return this.editarDaSelecao(0);
  }

  /** Tira um retrato da edicao atual, para a foto poder ser retomada do mesmo ponto. */
  private guardarEdicaoDaFotoAtual(): void {
    const item = this.selecaoDeFotos[this.editandoNaSelecao];
    if (item == null) {
      return;
    }
    const cropper = this.angularCropper?.cropper as any;
    item.edicao = {
      filtro: this.activeFilter,
      zoom: this.zoomVal,
      endireitar: this.straightenVal,
      rotacao: this.baseRotation,
      escalaX: this.scaleValX,
      escalaY: this.scaleValY,
      adj: { ...this.adj },
      recorte: (() => { try { return cropper?.getData(); } catch { return null; } })(),
    };

    // A miniatura e redesenhada AQUI, e nao em quem chama.
    //
    // Este e o unico ponto por onde TODA saida de uma foto passa: Concluir numa folha, tocar
    // em outra miniatura da tira, qualquer caminho. Atualizar no chamador deixava dois furos:
    // trocar o FILTRO e dar Concluir nao mexia na miniatura (o guard olhava so o Recortar), e
    // trocar de foto direto pela tira, sem passar pelo Concluir, deixava a miniatura velha.
    this.atualizarMiniaturaDaSelecao(item);
  }

  /**
   * Devolve a foto ao ponto em que o usuario a deixou.
   *
   * Chamada do `onCropperReady`, e nao do `editarDaSelecao`: o recorte so pode ser aplicado
   * depois de o cropperjs ter medido a imagem NOVA. Aplicar antes seria escrever numa caixa
   * que ainda vai ser refeita.
   */
  private restaurarEdicaoDaFotoAtual(): boolean {
    const edicao = this.selecaoDeFotos[this.editandoNaSelecao]?.edicao;
    if (!edicao) {
      return false;
    }

    this.activeFilter = edicao.filtro;
    // `edicao.zoom` NAO e restaurado: o `enquadrar` que roda logo depois reescreve a escala da
    // tela e zera o `zoomVal`, entao devolver o valor antigo so deixaria o slider mentindo. O
    // que de fato persiste da escolha do usuario e o RECORTE em coordenadas naturais, abaixo.
    this.straightenVal = edicao.endireitar;
    this.baseRotation = edicao.rotacao;
    this.scaleValX = edicao.escalaX;
    this.scaleValY = edicao.escalaY;
    this.adj = { ...edicao.adj };
    this.recomputeFilter();

    const cropper = this.angularCropper?.cropper as any;
    try {
      cropper?.scale(edicao.escalaX, edicao.escalaY);
      cropper?.rotateTo(edicao.rotacao + edicao.endireitar);
      if (edicao.recorte) {
        cropper?.setData(edicao.recorte);
      }
    } catch { /* noop */ }
    return true;
  }

  /** Abre no editor a foto que o usuário tocou na tira. */
  public async editarDaSelecao(indice: number): Promise<boolean> {
    const item = this.selecaoDeFotos[indice];
    if (item == null) {
      return false;
    }

    // Antes de sair da foto atual, guarda o que foi feito nela.
    if (this.editandoNaSelecao !== indice) {
      this.guardarEdicaoDaFotoAtual();
    }

    if (!this.definirSlotDeDestino()) {
      this.util.presentToast(this.toastCtrl, this.translate.instant('photoQueueNoSlots'), 4000);
      return false;
    }

    return this.carregarItemNoCropper(indice);
  }

  /**
   * Poe a foto do item no cropper. Nao decide slot e nao espera ficar pronto — para esperar,
   * `aguardarCropperPronto()` logo depois.
   */
  private async carregarItemNoCropper(indice: number): Promise<boolean> {
    const item = this.selecaoDeFotos[indice];
    if (item == null) {
      return false;
    }

    this.editandoNaSelecao = indice;
    // `readAsBase64` de uma foto de camera moderna leva tempo, e depois dela o cropperjs
    // ainda decodifica e renderiza. Era essa soma que aparecia como tela parada ao voltar da
    // galeria: o loader antigo saia quando o ARQUIVO terminava de ser lido, nao quando a
    // tela ficava pronta. Agora ele vive ate o `onCropperReady`.
    this.aguardandoCropper = true;
    const base64 = await this.readAsBase64(item.foto);
    this.myImage = this.sanitizer.bypassSecurityTrustUrl(base64);
    this.showCropper = true;

    // Só zera o editor para foto que AINDA NÃO foi editada. Para quem já tem edição salva,
    // zerar aqui apagaria filtro e ajustes antes de o `onCropperReady` restaurá-los — e o
    // usuário veria a foto piscar sem o tratamento dele.
    if (!item.edicao) {
      this.resetEditorState();
    }
    return true;
  }

  /**
   * Em qual slot a próxima confirmação vai cair.
   *
   * A primeira vai para o slot que o usuário tocou — é o que ele pediu ao tocar nele, e é o
   * comportamento de sempre. Da segunda em diante, o primeiro slot vazio. Recalcular a cada
   * vez, e não reservar de antemão, é o que permite a tira: a ordem de edição passa a ser
   * escolha do usuário.
   */
  private definirSlotDeDestino(): boolean {
    const alvo = this.slotInicialUsado
      ? this.pictures.findIndex((p) => p === this.grayPlus)
      : this.slotInicial;

    if (alvo < 0) {
      return false;
    }

    this.workingOnIndex = alvo;

    // E PRECISO gravar no Preferences também. O `saveCropped()` LÊ `WORKING_ON_INDEX` de lá
    // e sobrescreve `this.workingOnIndex` com o valor lido — era por isso que toda foto da
    // leva subia para o MESMO slot, cada uma sobrescrevendo a anterior, e no fim só uma
    // ficava salva. Atribuir só na memória não bastava.
    Preferences.set({ key: 'WORKING_ON_INDEX', value: JSON.stringify(alvo) });
    return true;
  }

  /**
   * Chamado quando a foto do editor foi enviada. Tira ela da tira e abre a próxima, se
   * houver. Devolve false quando a leva acabou — aí quem chamou fecha o editor.
   */
  private async concluirFotoDaSelecao(): Promise<boolean> {
    this.slotInicialUsado = true;

    if (this.editandoNaSelecao >= 0) {
      this.selecaoDeFotos.splice(this.editandoNaSelecao, 1);
    }
    this.editandoNaSelecao = -1;

    if (this.selecaoDeFotos.length === 0) {
      this.limparSelecaoDeFotos();
      return false;
    }

    return this.editarDaSelecao(0);
  }

  private limparSelecaoDeFotos(): void {
    this.selecaoDeFotos = [];
    this.editandoNaSelecao = -1;
    this.slotInicialUsado = false;
  }

  private async readFromDisk(options: any, indiceTocado: number) {
    const loader = await this.loadingCtrl.create({
      message: this.translate.instant('pleaseWait'),
    });

    /* A CARGA E CONTINUA: sobe ao abrir a galeria e so sai quando o editor esta na tela.
    
       No NATIVO o loader sobe ANTES do seletor. O seletor do sistema cobre a tela enquanto o
       usuario escolhe, e quando ele volta da galeria ja encontra o loading no ar — em vez de
       cair na tela de perfil e esperar ali. E o comportamento pedido.
    
       Na WEB nao da para subir antes: o seletor e um `<input type="file">` e esperar o
       `present()` quebra o "user gesture" — o iOS Safari BLOQUEIA a abertura e a tela fica
       presa no "aguarde". Ali o loader sobe logo APOS a escolha, que e o mais cedo possivel.
    
       Isto reverte de proposito uma decisao anterior, que derrubava o loader logo depois da
       escolha para deixar so o indicador de dentro do editor. */
    let noAr = false;
    const subirLoader = async () => {
      if (!noAr) {
        noAr = true;
        await loader.present();
      }
    };
    if (this.isNative) {
      await subirLoader();
    }

    try {
      // UMA foto -> `getPhoto`, nao `pickImages`. O `limit: 1` do `pickImages` NAO limita no
      // Android: o plugin so honra o pedido quando e MAIOR que 1 —
      // `getContractForCall` (LegacyCameraFlow.java) faz
      // `limit > 1 ? PickMultipleVisualMedia(limit) : PickMultipleVisualMedia()`, e esse
      // construtor sem argumento usa o MAXIMO do sistema. Ou seja, pedir 1 abria o seletor
      // ILIMITADO — foi o que aconteceu com o perfil cheio, que pede exatamente 1. O
      // `getPhoto` entra pelo `openPhotos(call, false)`, o ramo de selecao unica de verdade.
      const escolher = options?.limit === 1
        ? Camera.getPhoto(options).then((foto) => ({ photos: foto ? [foto] : [] }))
        : Camera.pickImages(options);

      const results = await escolher;
      console.log('pictures - results: ' + JSON.stringify(results));
      if (results == null || results.photos.length == 0) {
        console.log('pictures - results == []. Will return');
        return;
      }

      await subirLoader();

      // O loader fica no ar ATE aqui: `prepararSelecaoDeFotos` monta o editor e le o arquivo da
      // primeira foto antes de resolver, entao quando ele volta a tela de edicao esta pronta. O
      // indicador de dentro do editor assume daqui, cobrindo so a montagem do cropper.
      //
      // Todas as fotos escolhidas entram na selecao; o editor abre com a primeira e as demais
      // esperam a vez. Antes, o laco daqui processava a primeira e dava `return`.
      const abriu = await this.prepararSelecaoDeFotos(results.photos as Photo[], indiceTocado);
      if (!abriu) {
        this.util.presentToast(this.toastCtrl, this.translate.instant('photoQueueNoSlots'), 4000);
      }
    } catch (error) {
      console.error('pictures - Error getting image caught: ' + JSON.stringify(error));
    } finally {
      if (noAr) {
        await loader.dismiss();
      }
    }
  }

  private async readAsBase64(photo: Photo) {
    // Fetch the photo, read as a blob, then convert to base64 format
    const response = await fetch(photo.webPath!);
    const blob = await response.blob();
    return await this.convertBlobToBase64(blob) as string;
  }

  private convertBlobToBase64 = (blob: Blob) => new Promise((resolve, reject) => {
    const fileReader = new FileReader();
    const zoneOriginalInstance = (fileReader as any).__zone_symbol__originalInstance;
    const reader = zoneOriginalInstance || fileReader;
    reader.onerror = reject;
    reader.onload = () => {
      resolve(reader.result);
    };
    reader.readAsDataURL(blob);
  });

  async showModalAlert(message: any) {
    const alert = this.alertCtrl.create({
      //title: this.translate.instant('statisticalOnly'),
      subHeader: message,
      buttons: [
        {
          text: 'OK',
          handler: () => { }
        }
      ]
    });

    (await alert).present();
  }


  reset() {
    // Sem isto, tocar em Original nos 200-300ms seguintes ao fechar uma folha zerava os
    // controles e NAO mexia na imagem: o `cropper.reset()` sai cedo quando `disabled`.
    this.acordarCropper();

    this.angularCropper.cropper.reset();
    this.resetEditorState();

    // `applyRotation()` depois do `resetEditorState()` — que acabou de zerar `baseRotation` e
    // `straightenVal` — e portanto um `rotateTo(0)`.
    //
    // Nao e redundante: o `reset()` do cropperjs devolve `canvasData` a partir de
    // `initialCanvasData`, e esse retrato guarda a geometria de ANTES de qualquer rotacao de
    // 90 graus. Girar, fechar a folha (o que dispara `cropper.resize()`) e tocar em Original
    // devolvia uma tela com `aspectRatio` girado: a foto voltava cortada ~12,5% de cada lado,
    // com tarjas em cima e embaixo — e era esse estado que ia para o arquivo salvo. O
    // `rotateTo` entra em `renderCanvas(true, true)` e reescreve `aspectRatio` e os
    // `natural*` a partir do `imageData` ja zerado.
    this.applyRotation();

    // O `reset` do cropperjs devolve a tela ao estado inicial — menor que a caixa. Reenquadra
    // para o Original deixar a foto do mesmo tamanho com que ela abriu.
    this.enquadrar(this.folhaAberta === 'recortar' ? 'foto' : 'recorte');
  }

  /** Ao abrir o crop, centraliza a caixa de seleção no container (evita ela iniciar muito pra baixo).
   *  Recentra em alguns momentos: no iOS/web o layout do cropper assenta DEPOIS do 'ready', então
   *  um único setTimeout(0) mede cedo demais (por isso só centralizava no Android). */
  /* ---- Editor em tela cheia, no modelo do Instagram ---------------------------------

     Fila de ferramentas no rodape; tocar numa abre uma FOLHA com os controles e uma barra
     Cancelar / Titulo / Concluir. O ganho de area nao vem de manter a foto fixa — vem de o
     editor ser TELA CHEIA, sem o `ion-padding` do conteudo e sem cromo claro em volta:
     medido, a foto vai de 196x245 para 285x356 no iPhone SE (+111%).

     A melhoria sobre o Instagram esta no CANCELAR: aqui ele restaura de verdade, por
     snapshot do filtro, dos ajustes e do recorte. Antes nao havia como desfazer uma
     experimentacao sem refazer a foto inteira. */

  /** Fotos desta leva que ainda nao foram enviadas: ver `selecaoDeFotos`. */
  /** Folha aberta, ou null quando so a fila de ferramentas aparece. */
  public folhaAberta: 'recortar' | 'ajustar' | 'filtros' | null = null;

  /** true entre escolher a foto e o cropper estar desenhado. Segura o indicador de carga. */
  public aguardandoCropper: boolean = false;

  /** Quem esta esperando o cropper carregar a foto. Ver `aguardarCropperPronto`. */
  private resolverCropperPronto: (() => void) | null = null;

  private soltarVoltarNativo?: { unsubscribe: () => void };

  private observadorDoCromo?: ResizeObserver;

  /**
   * Escreve em `--editor-cromo-cur` a altura REAL do rodape do editor.
   *
   * O token no SCSS e so fallback. Numero escrito a mao ali envelhece: eram 303 e 323 em dois
   * lugares, ninguem atualizou quando a tira de miniaturas entrou, e a reserva da folha ficou
   * ~91px maior do que a folha realmente ocupa — 91px de foto jogados fora a cada vez que o
   * Recortar abria. Medindo, nao ha numero para envelhecer.
   *
   * O `offsetHeight` do rodape JA inclui o safe-area, que esta no padding dele; por isso as
   * contas que consomem o token nao descontam `env(safe-area-inset-bottom)` de novo, e o
   * `env()` vive dentro dos tokens de fallback.
   */
  private medirCromoDoEditor(): void {
    const host = this.elementoHost?.nativeElement;
    const rodape = host?.querySelector('.box-crop-options') as HTMLElement | null;
    if (!host || !rodape) {
      return;
    }
    const altura = rodape.offsetHeight;
    if (altura <= 0) {
      return; // ainda nao desenhado: o fallback do SCSS segue valendo
    }
    host.style.setProperty('--editor-cromo-cur', altura + 'px');
  }

  /** Mede agora e continua medindo: a altura do rodape muda quando a folha abre e fecha. */
  private observarCromoDoEditor(): void {
    const rodape = this.elementoHost?.nativeElement?.querySelector('.box-crop-options');
    if (!rodape) {
      return;
    }
    this.medirCromoDoEditor();
    if (typeof ResizeObserver === 'undefined') {
      return; // sem observador o fallback vale; nenhuma tela quebra
    }
    // Reobserva SEMPRE: o rodape e recriado a cada abertura do editor (`*ngIf="showCropper"`),
    // e manter o observador antigo o deixaria preso num elemento que ja saiu do DOM.
    this.observadorDoCromo?.disconnect();
    // Fora da zona do Angular: o callback so escreve uma custom property, e dentro da zona
    // dispararia uma deteccao de mudancas a cada quadro da animacao da folha.
    this.ngZone.runOutsideAngular(() => {
      this.observadorDoCromo = new ResizeObserver(() => this.medirCromoDoEditor());
      this.observadorDoCromo.observe(rodape);
    });
  }

  private soltarCromoDoEditor(): void {
    this.observadorDoCromo?.disconnect();
    this.observadorDoCromo = undefined;
    this.elementoHost?.nativeElement?.style.removeProperty('--editor-cromo-cur');
  }

  /**
   * Parametro escolhido dentro da folha Ajustar.
   *
   * Os 4 sliders de uma vez eram a razao de o painel antigo precisar de 118px congelados.
   * Aqui e um circulo por parametro e UM slider, o do escolhido — o mesmo caminho do
   * Instagram, e o que permite a folha ser baixa.
   */
  public ajusteAtivo: 'bright' | 'contrast' | 'sat' | 'warm' | null = null;

  public readonly ajustes: { chave: 'bright' | 'contrast' | 'sat' | 'warm'; labelKey: string; icone: string; min: number; max: number; passo: number }[] = [
    { chave: 'bright', labelKey: 'cropBrightness', icone: 'sunny-outline', min: 0.6, max: 1.4, passo: 0.01 },
    { chave: 'contrast', labelKey: 'cropContrast', icone: 'contrast-outline', min: 0.6, max: 1.5, passo: 0.01 },
    { chave: 'sat', labelKey: 'cropSaturation', icone: 'color-palette-outline', min: 0, max: 2, passo: 0.01 },
    { chave: 'warm', labelKey: 'cropWarmth', icone: 'flame-outline', min: 0, max: 0.6, passo: 0.01 },
  ];

  /**
   * O que o Cancelar da folha precisa devolver.
   *
   * Guarda a GEOMETRIA DA TELA, e nao so o recorte, porque `getData`/`setData` carregam
   * rotacao e espelho mas NAO a escala do canvas: um instantaneo so com o recorte e
   * estruturalmente incapaz de desfazer um Zoom. E guarda tambem os contadores do
   * componente, que nao vivem no cropper e ficavam dessincronizados depois do Cancelar.
   */
  private instantaneoDaFolha: {
    filtro: string;
    adj: { bright: number; contrast: number; sat: number; warm: number };
    recorte: unknown;
    tela: unknown;
    zoom: number;
    endireitar: number;
    rotacao: number;
    escalaX: number;
    escalaY: number;
  } | null = null;
  private timersDeCentralizacao: ReturnType<typeof setTimeout>[] = [];
  private soltarTransicaoDaFolha?: () => void;

  /**
   * Escala da tela no enquadramento corrente — a referencia do slider de Zoom.
   *
   * O `zoomVal` e um multiplicador ABSOLUTO sobre ela: 1 = como o `enquadrar` deixou, 2 = o
   * dobro. Antes o `onZoom` aplicava `cropper.zoom(v - zoomVal)`, um delta RELATIVO, e isso
   * errava de duas formas ao mesmo tempo. Primeira: o `ion-range` dispara `input` a cada passo
   * de 0,02, entao arrastar de 1 a 1,6 aplicava 1,02^30 ~= 1,81 de escala real, nao 1,6.
   * Segunda: todo `enquadrar` reescreve a escala da tela sem avisar o `zoomVal`, entao o
   * minimo do slider deixava de coincidir com o ajuste e voltar ao minimo deixava a foto
   * MENOR que a caixa.
   */
  private escalaDeAjuste = 1;

  /** Roda o `encerrar` pendente da transicao da folha, se houver. Ver `acordarCropper`. */
  private encerrarTransicaoDaFolha?: () => void;

  /**
   * Fecha a janela em que o cropper esta DESLIGADO pela animacao da folha.
   *
   * `recalcularCropperAoFimDaTransicao` faz `cropper.disable()` e so reabilita no
   * `transitionend` ou na rede de 300ms. Nessa janela, os botoes do editor eram no-op SILENCIOSO
   * no cropperjs — que sai cedo quando `disabled` — mas os contadores do componente
   * (`baseRotation`, `scaleValX`, `zoomVal`) avancavam. O resultado era a UI contando uma coisa
   * e a imagem outra: o Original zerava os controles e a foto continuava girada, e um toque em
   * girar depois disso somava sobre um valor que a imagem nunca teve.
   *
   * Em vez de bloquear os botoes e deixar o toque cair no vazio, antecipa o fim da transicao: o
   * `enable()` + `getData/resize/setData` acontecem agora, e a acao do usuario encontra um
   * cropper vivo.
   */
  private acordarCropper(): void {
    this.encerrarTransicaoDaFolha?.();
  }

  /** A classe no host muda o token de altura, que a foto e a folha leem juntos. */
  @HostBinding('class.folha-aberta')
  get hostFolhaAberta(): boolean {
    return this.folhaAberta !== null;
  }

  /**
   * Liga a classe que faz o delimitador do recorte aparecer.
   *
   * O seletor no SCSS e `:host:not(.recortando)`, no HOST, porque os elementos do cropperjs
   * ficam fora do alcance do encapsulamento do componente — precisa de um ancestral que o
   * Angular marque, mais `::ng-deep` para atravessar.
   */
  @HostBinding('class.recortando')
  get hostRecortando(): boolean {
    return this.folhaAberta === 'recortar';
  }

  public abrirFolha(ferramenta: 'recortar' | 'ajustar' | 'filtros'): void {
    const cropper = this.angularCropper?.cropper as any;
    this.instantaneoDaFolha = {
      filtro: this.activeFilter,
      adj: { ...this.adj },
      recorte: (() => { try { return cropper?.getData(); } catch { return null; } })(),
      tela: (() => { try { return cropper?.getCanvasData(); } catch { return null; } })(),
      zoom: this.zoomVal,
      endireitar: this.straightenVal,
      rotacao: this.baseRotation,
      escalaX: this.scaleValX,
      escalaY: this.scaleValY,
    };

    this.folhaAberta = ferramenta;
    this.editorTab = ferramenta; // mantem coerente o codigo existente que le editorTab
    this.ajusteAtivo = ferramenta === 'ajustar' ? 'bright' : null;
    this.recalcularCropperAoFimDaTransicao();
  }

  /** Descarta o que foi experimentado na folha. */
  public cancelarFolha(): void {
    const instantaneo = this.instantaneoDaFolha;
    if (instantaneo) {
      this.activeFilter = instantaneo.filtro;
      this.adj = { ...instantaneo.adj };
      this.recomputeFilter();

      // Os contadores do componente nao vivem no cropper: sem devolve-los, um toque em girar
      // depois de um Cancelar somava 90 sobre o valor ANTIGO e a foto dava 180 de uma vez.
      this.zoomVal = instantaneo.zoom;
      this.straightenVal = instantaneo.endireitar;
      this.baseRotation = instantaneo.rotacao;
      this.scaleValX = instantaneo.escalaX;
      this.scaleValY = instantaneo.escalaY;

      // A TELA volta antes do recorte, e isso nao e ordem arbitraria.
      //
      // O slider de Zoom vive dentro da folha do Recortar e escala o canvas sem mexer na
      // caixa de recorte. Com o canvas ampliado, o `setData` do instantaneo pedia uma caixa
      // maior do que o `maxCropBoxWidth` que o `viewMode: 1` permite — e o `renderCropBox` do
      // cropperjs, nesse caminho, grampeia a largura E DESCARTA o `left`. O Cancelar entregava
      // um recorte mais apertado e deslocado, que era o que ia para a miniatura e para o
      // arquivo salvo. Com a tela de volta ao tamanho do instantaneo, a mesma caixa cabe e
      // nada e grampeado.
      this.aplicarTelaERecorte(instantaneo.tela, instantaneo.recorte);
    }
    this.fecharFolha();
  }

  /**
   * Mantem o que foi feito e, no caso do Recortar, APLICA o recorte na miniatura da tira.
   *
   * Sem isso, Concluir fechava a folha e nada mudava na tela: o recorte só aparecia no
   * Salvar, e o usuario nao tinha como saber se tinha surtido efeito. Atualizar a miniatura
   * e a confirmacao visual de que aquela foto ja esta recortada.
   */
  public concluirFolha(): void {
    this.guardarEdicaoDaFotoAtual(); // ja redesenha a miniatura
    this.fecharFolha();
  }

  /**
   * Redesenha a miniatura com o recorte E os filtros atuais, para a tira mostrar a foto
   * como ela vai ficar — e nao a original.
   *
   * Recebe o item por parametro em vez de reler `editandoNaSelecao`: quem chama acabou de
   * resolver qual item e, e reler o indice abriria espaco para redesenhar a miniatura
   * ERRADA se o indice tiver mudado no meio.
   */
  private atualizarMiniaturaDaSelecao(item: { foto: Photo; thumb: string; edicao?: EdicaoDaFoto }): void {
    try {
      // Aqui o teto FICA, ao contrario do export: a saida esta fixada em `width: 160`, entao
      // `maxWidth/maxHeight` limita apenas a fonte intermediaria que o cropperjs aloca antes de
      // reamostrar (ver `cropper.js` ~894-952) — e e exatamente ela que se quer limitar.
      const canvas = (this.angularCropper?.cropper as any)
        ?.getCroppedCanvas({ width: 160, maxWidth: 2400, maxHeight: 3000 });
      if (!canvas || canvas.width === 0) {
        return;
      }
      item.thumb = this.bakeFilter(canvas).toDataURL('image/jpeg', 0.7);
    } catch { /* a miniatura e cosmetica: falhar aqui nao pode travar o fluxo */ }
  }

  private fecharFolha(): void {
    this.folhaAberta = null;
    this.ajusteAtivo = null;
    this.instantaneoDaFolha = null;
    this.recalcularCropperAoFimDaTransicao();
  }

  /**
   * O cropperjs NAO observa o container: o listener de `resize` dele esta ligado so na
   * window, entao mudar a altura por CSS nao dispara recalculo e a caixa de recorte fica
   * com a geometria antiga dentro de uma caixa nova.
   *
   * `disable()` durante a animacao porque um arraste no meio calcularia deltas contra um
   * `containerData` velho; os handlers saem cedo quando `disabled`. No fim,
   * getData -> resize -> setData nessa ordem, porque `setData` exige `ready && !disabled`.
   */
  private recalcularCropperAoFimDaTransicao(): void {
    // Decidido AGORA, e nao dentro do `encerrar`: aquele roda 200-300ms depois, e ler o estado
    // da folha de la pegaria o estado de outra ferramenta se o usuario tiver trocado no meio.
    const enquadramento: 'recorte' | 'foto' = this.folhaAberta === 'recortar' ? 'foto' : 'recorte';
    const cropper = this.angularCropper?.cropper as any;
    const palco = document.querySelector('.block-cropper') as HTMLElement | null;
    if (!cropper || !palco) {
      return;
    }

    try { cropper.disable(); } catch { /* noop */ }

    this.soltarTransicaoDaFolha?.();
    let encerrado = false;
    const encerrar = () => {
      if (encerrado) { return; }
      encerrado = true;
      this.encerrarTransicaoDaFolha = undefined;
      // RELE a instancia, em vez de usar a capturada no inicio. Se a foto trocar durante a
      // transicao, o angular-cropperjs destroi o cropper e cria outro: o `resize()` cairia na
      // instancia morta e o cropper novo ficaria sem recalculo, com a geometria da caixa antiga.
      const vivo = this.angularCropper?.cropper as any;
      if (!vivo) { return; }
      try {
        vivo.enable();
        const dados = vivo.getData();
        vivo.resize();
        vivo.setData(dados);
      } catch { /* noop */ }
      // No Recortar a foto inteira tem de aparecer, para o usuario escolher a area; em
      // qualquer outro estado quem aparece e o resultado recortado.
      this.enquadrar(enquadramento);
    };
    const aoFim = () => encerrar();
    palco.addEventListener('transitionend', aoFim, { once: true });
    // `transitionend` nao dispara se a transicao for interrompida (tocar em outra
    // ferramenta no meio), e sem esta rede o cropper ficaria desligado para sempre.
    const rede = setTimeout(encerrar, 300);
    this.encerrarTransicaoDaFolha = encerrar;
    this.soltarTransicaoDaFolha = () => {
      palco.removeEventListener('transitionend', aoFim);
      clearTimeout(rede);
    };
  }

  /** Rotulo do parametro de ajuste em foco, para a folha nomear o que o slider mexe. */
  public get rotuloDoAjusteAtivo(): string {
    const achado = this.ajustes.find((a) => a.chave === this.ajusteAtivo);
    return achado ? achado.labelKey : '';
  }

  public get faixaDoAjusteAtivo(): { min: number; max: number; passo: number; valor: number } {
    const a = this.ajustes.find((x) => x.chave === this.ajusteAtivo) || this.ajustes[0];
    return { min: a.min, max: a.max, passo: a.passo, valor: this.adj[a.chave] };
  }

  /**
   * Avisa quem estava esperando que o cropper carregou a foto.
   *
   * O `ready` do angular-cropperjs pode chegar MAIS DE UMA VEZ por foto: a lib registra um
   * listener novo a cada `load` da <img> e nunca remove os antigos. Uma Promise se resolve uma
   * unica vez, entao quem espera por aqui nao corre esse risco — era justamente o que tornava
   * o antigo encadeamento por evento do "salvar tudo" imprevisivel.
   */
  private avisarCropperPronto(): void {
    const resolver = this.resolverCropperPronto;
    this.resolverCropperPronto = null;
    resolver?.();
  }

  /** Espera o cropper terminar de carregar a foto atual. */
  private aguardarCropperPronto(): Promise<void> {
    this.avisarCropperPronto(); // solta quem esperava a foto anterior: ela nao vem mais
    if (!this.aguardandoCropper) {
      return Promise.resolve();
    }
    return new Promise<void>((resolve) => {
      // Rede de seguranca: se a imagem nao carregar (arquivo invalido, permissao revogada no
      // meio), o `ready` nunca chega e sem isto o laco do salvar ficaria parado para sempre.
      const rede = setTimeout(() => {
        this.resolverCropperPronto = null;
        resolve();
      }, 8000);
      this.resolverCropperPronto = () => {
        clearTimeout(rede);
        resolve();
      };
    });
  }

  /**
   * Enquadra o que o usuario tem de ver, SEM mexer no recorte.
   *
   * `'recorte'` escala e desloca a foto para o RECORTE preencher a caixa, centralizado — e o
   * que se ve fora do Recortar, onde a foto aparece ja cortada. `'foto'` faz o contrario:
   * deixa a foto INTEIRA visivel e centralizada, que e o que o Recortar precisa para o usuario
   * escolher a area.
   *
   * Os dois problemas que isto resolve: a foto abria pequena, ocupando menos da metade da
   * caixa; e, ao voltar numa foto ja recortada, o pedaco visivel aparecia no ponto da foto
   * onde o recorte tinha sido feito, com sobra preta assimetrica em volta, em vez de
   * centralizado.
   *
   * A INVARIANTE e o recorte em coordenadas naturais: `getData()` antes e depois tem de ser o
   * mesmo numero, porque e dele que sai o arquivo salvo e a miniatura. Por isso a sequencia e
   * `getData` -> mexer na tela -> `setData`: a transformacao e uma semelhanca (mesma escala em
   * x e y) em torno do alvo, entao a regiao da imagem sob o recorte nao muda.
   *
   * O `clear()` antes de mexer na tela nao e enfeite. Com `viewMode: 1` e um recorte ativo, o
   * `limitCanvas` prende a tela ao recorte (`maxLeft = cropBox.left`, `minWidth =
   * cropBox.width`): qualquer tentativa de escalar a tela primeiro sairia grampeada contra o
   * recorte ANTIGO. Sem recorte ativo, esses limites nao existem e a tela se move livre; o
   * `crop()` logo depois recria a caixa e o `setData` devolve o recorte exato.
   */
  private enquadrar(modo: 'recorte' | 'foto'): void {
    const cropper = this.angularCropper?.cropper as any;
    if (!cropper) {
      return;
    }
    try {
      const dados = cropper.getData();
      const container = cropper.getContainerData();
      const tela = cropper.getCanvasData();
      const recorte = cropper.getCropBoxData();
      if (!container?.width || !tela?.width || !recorte?.width) {
        return;
      }

      const alvo = modo === 'recorte' ? recorte : tela;
      const k = Math.min(container.width / alvo.width, container.height / alvo.height);
      if (!isFinite(k) || k <= 0) {
        return;
      }

      const alvoEsquerda = (container.width - alvo.width * k) / 2;
      const alvoTopo = (container.height - alvo.height * k) / 2;

      this.aplicarTelaERecorte(
        {
          // so `width`: o `setCanvasData` deriva a altura do aspectRatio da tela, e passar as
          // duas abriria espaco para um arredondamento incoerente entre elas.
          left: alvoEsquerda - (alvo.left - tela.left) * k,
          top: alvoTopo - (alvo.top - tela.top) * k,
          width: tela.width * k,
        },
        dados
      );

      // Novo enquadramento, nova referencia do slider — e o slider volta ao minimo, porque e
      // exatamente aqui que ele esta agora. Sem isto o 1 do slider apontava para um
      // enquadramento que nao existe mais.
      //
      // O denominador e o `naturalWidth` do CANVAS, e nao o da imagem. Os dois divergem: o
      // `renderCanvas` reescreve `canvasData.naturalWidth` com o tamanho do retangulo
      // ENVOLVENTE da imagem girada, enquanto `imageData.naturalWidth` nunca muda. E o
      // `zoomTo` multiplica justamente o do canvas. Com `imageData`, qualquer enquadramento
      // feito com a foto girada ou endireitada deixava o 1 do slider 33% acima do ajuste em
      // retrato — o primeiro toque saltava — e 25% abaixo em paisagem. Pior: como o recorte sai
      // do canvas ja saltado, o erro ia para a miniatura e para o arquivo salvo.
      if (tela.naturalWidth) {
        this.escalaDeAjuste = (tela.width * k) / tela.naturalWidth;
      }
      this.zoomVal = 1;
    } catch { /* noop */ }
  }

  /**
   * Escreve tela e recorte no cropper na UNICA ordem que o `viewMode: 1` aceita.
   *
   * Com um recorte ativo, o `limitCanvas` prende a tela ao recorte (`maxLeft =
   * cropBox.left`, `minWidth = cropBox.width`): mexer na tela primeiro sai grampeado contra o
   * recorte ANTIGO. Sem recorte ativo esses limites nao existem, entao a sequencia e
   * `clear` -> tela -> `crop` -> recorte. O `enquadrar` e o `cancelarFolha` usam a mesma.
   */
  private aplicarTelaERecorte(tela: unknown, recorte: unknown): void {
    const cropper = this.angularCropper?.cropper as any;
    if (!cropper) {
      return;
    }
    const t = tela as { left?: number; top?: number; width?: number } | null;
    try {
      cropper.clear();
      if (t && typeof t.width === 'number') {
        cropper.setCanvasData({ left: t.left, top: t.top, width: t.width });
      }
      cropper.crop();
      if (recorte) {
        cropper.setData(recorte);
      }
    } catch { /* noop */ }
  }

  /**
   * Centraliza o recorte nas COORDENADAS NATURAIS da imagem (nao no container renderizado).
   * Isso fica igual em Android, iOS e web — o antigo fator por-container (0.35) so acertava no
   * Android porque compensava um offset de render especifico daquela plataforma.
   */
  private centralizarRecorteNaImagem(): void {
    const cropper = this.angularCropper?.cropper as any;
    if (!cropper) return;
    try {
      const img = cropper.getImageData();
      const data = cropper.getData();
      if (!img?.naturalWidth || !data?.width) return; // ainda não medido
      cropper.setData({
        x: (img.naturalWidth - data.width) / 2,
        y: (img.naturalHeight - data.height) / 2,
      });
    } catch { /* noop */ }
  }

  onCropperReady(): void {
    this.aguardandoCropper = false;
    // O rodape ja existe neste ponto; daqui para a frente o `--editor-cromo-cur` passa a ser
    // medido em vez de estimado.
    this.observarCromoDoEditor();

    // Se esta foto ja foi editada antes, o estado dela manda — e os timers de centralizacao
    // NAO podem rodar, senao sobrescreveriam o recorte restaurado com um centralizado.
    if (this.restaurarEdicaoDaFotoAtual()) {
      this.cancelarCentralizacao();
      // Centraliza o pedaco recortado na caixa. Sem isto ele reaparecia no ponto da foto onde
      // o recorte foi feito, com sobra preta assimetrica — o relato de "nao fica mais
      // centralizada, fica no ponto onde ocorreu o crop".
      this.enquadrar(this.folhaAberta === 'recortar' ? 'foto' : 'recorte');
      this.avisarCropperPronto();
      return;
    }

    // Os cinco disparos existiam porque a imagem pode nao estar medida no primeiro frame.
    // O problema: eles seguiam disparando DEPOIS de o usuario ja ter arrastado a caixa, e um
    // timer atrasado APAGAVA o recorte dele, trocando por um centralizado. Agora param na
    // primeira centralizacao que da certo, e qualquer toque na caixa cancela o resto.
    this.cancelarCentralizacao();

    const centralizarUmaVez = () => {
      if (this.timersDeCentralizacao.length === 0) {
        return; // ja cancelado por toque do usuario
      }
      const cropper = this.angularCropper?.cropper as any;
      const img = cropper?.getImageData?.();
      this.centralizarRecorteNaImagem();
      if (img?.naturalWidth) {
        this.cancelarCentralizacao(); // mediu, centralizou: nao precisa mais
        // A foto abre no tamanho da caixa, e nao em menos da metade dela.
        this.enquadrar('recorte');
      }
    };

    this.timersDeCentralizacao = [0, 150, 350, 600, 900].map((ms) => setTimeout(centralizarUmaVez, ms));

    // `cropstart` e o primeiro evento de interacao do cropperjs. A partir dele, a posicao
    // da caixa e do usuario e nenhum timer pode sobrescrever.
    // O `cropstart` e disparado pelo cropperjs no proprio <img> e BORBULHA, entao escutar no
    // container funciona e nao depende de tipo interno da lib.
    const palco = document.querySelector('.block-cropper') as HTMLElement | null;
    palco?.addEventListener('cropstart', () => this.cancelarCentralizacao(), { once: true });

    this.avisarCropperPronto();
  }

  private cancelarCentralizacao(): void {
    this.timersDeCentralizacao.forEach((t) => clearTimeout(t));
    this.timersDeCentralizacao = [];
  }

  clear() {
    this.angularCropper.cropper.clear();
  }

  /** Girar 90° no sentido horário. */
  rotate() {
    this.acordarCropper();
    this.baseRotation = (this.baseRotation + 90) % 360;
    this.applyRotation();
  }

  /** Girar 90° no sentido anti-horário. */
  rotateCcw() {
    this.acordarCropper();
    this.baseRotation = (this.baseRotation - 90 + 360) % 360;
    this.applyRotation();
  }

  zoom(zoomIn: boolean) {
    const factor = zoomIn ? 0.1 : -0.1;
    this.angularCropper.cropper.zoom(factor);
  }

  scaleX() {
    this.acordarCropper();
    this.scaleValX = this.scaleValX * -1;
    this.angularCropper.cropper.scaleX(this.scaleValX);
  }

  scaleY() {
    this.acordarCropper();
    this.scaleValY = this.scaleValY * -1;
    this.angularCropper.cropper.scaleY(this.scaleValY);
  }

  move(x: any, y: any) {
    this.angularCropper.cropper.move(x, y);
  }

  setEditorTab(tab: 'recortar' | 'ajustar' | 'filtros'): void {
    this.editorTab = tab;
  }

  /** Preset de filtro: aplica e zera os ajustes finos. */
  applyFilter(css: string): void {
    this.activeFilter = css || 'none';
    this.adj = { bright: 1, contrast: 1, sat: 1, warm: 0 };
    this.recomputeFilter();
  }

  /** Ajuste fino (brilho/contraste/saturacao/calor) — desmarca o preset. */
  onAdjust(key: 'bright' | 'contrast' | 'sat' | 'warm', ev: any): void {
    const v = parseFloat(ev?.target?.value ?? ev?.detail?.value);
    if (!isNaN(v)) this.adj[key] = v;
    this.activeFilter = 'none';
    this.recomputeFilter();
  }

  /** Zoom por slider (delta relativo no cropper). */
  onZoom(ev: any): void {
    const v = parseFloat(ev?.target?.value ?? ev?.detail?.value);
    if (isNaN(v)) return;
    this.acordarCropper();
    this.zoomVal = v;
    // `zoomTo` com a escala ABSOLUTA, e nao `zoom` com o delta: ver `escalaDeAjuste`.
    try { this.angularCropper.cropper.zoomTo(this.escalaDeAjuste * v); } catch { /* noop */ }
  }

  /** Endireitar por slider (rotacao fina somada aos passos de 90). */
  onStraighten(ev: any): void {
    const v = parseFloat(ev?.target?.value ?? ev?.detail?.value);
    if (isNaN(v)) return;
    this.acordarCropper();
    this.straightenVal = v;
    this.applyRotation();
  }

  private applyRotation(): void {
    try { (this.angularCropper.cropper as any).rotateTo(this.baseRotation + this.straightenVal); } catch { /* noop */ }
  }

  private recomputeFilter(): void {
    const parts: string[] = [];
    if (this.activeFilter && this.activeFilter !== 'none') parts.push(this.activeFilter);
    if (this.adj.bright !== 1) parts.push(`brightness(${this.adj.bright})`);
    if (this.adj.contrast !== 1) parts.push(`contrast(${this.adj.contrast})`);
    if (this.adj.sat !== 1) parts.push(`saturate(${this.adj.sat})`);
    if (this.adj.warm > 0) parts.push(`sepia(${this.adj.warm})`);
    this.previewFilter = parts.length ? parts.join(' ') : null;
  }

  private resetEditorState(): void {
    this.editorTab = 'recortar';
    this.activeFilter = 'none';
    this.zoomVal = 1;
    this.straightenVal = 0;
    this.baseRotation = 0;
    this.scaleValX = 1;
    this.scaleValY = 1;
    this.adj = { bright: 1, contrast: 1, sat: 1, warm: 0 };
    this.recomputeFilter();
  }

  /** Redesenha o canvas recortado aplicando o filtro/ajustes ativos (o
   *  getCroppedCanvas NAO carrega filtro CSS — "assamos" via ctx.filter). */
  private bakeFilter(src: HTMLCanvasElement): HTMLCanvasElement {
    if (!this.previewFilter) return src;
    try {
      const out = document.createElement('canvas');
      out.width = src.width;
      out.height = src.height;
      const ctx = out.getContext('2d') as CanvasRenderingContext2D & { filter: string };
      if (!ctx) return src;
      ctx.filter = this.previewFilter;
      ctx.drawImage(src, 0, 0);
      return out;
    } catch {
      return src;
    }
  }


  /**
   * Exclui a foto do slot `index`.
   *
   * O `index` e o slot DO SERVIDOR, e e por isso que nada aqui compacta a grade.
   *
   * O bug que motivou esta versao: o cliente compactava (`solveHoles`, de dentro do
   * `savePicturesOnUserData`) e o servidor NAO — o `/soul/image/delete` faz `$unset`, que
   * deixa buraco — e a compactacao so viaja com `reorderPictures=true`, que sai apenas do
   * `saveUserData()`. Da segunda exclusao em diante o indice enviado nao correspondia mais ao
   * slot do servidor. Medido com A B C D: excluir B e depois D fazia o servidor apagar C, e o
   * arquivo sai do R2 junto, sem volta — enquanto o D que o usuario pediu continuava la.
   *
   * Tres coisas sustentam o conserto, e nenhuma delas e um numero:
   * 1. o `savePicturesOnUserData` nao compacta mais, entao indice da tela == slot do servidor;
   * 2. nao existe mais um `this.userData['picture' + index] = null` DEPOIS daquela escrita —
   *    ele anulava o slot que a compactacao acabara de preencher com a foto de tras (medido:
   *    com A B C, excluir B deixava o userData so com A, perdendo o C);
   * 3. uma exclusao por vez. Sem trava, duas requisicoes no ar liam e reescreviam
   *    `this.pictures` em cima uma da outra.
   *
   * A tela so muda DEPOIS do servidor confirmar. Antes a foto desaparecia na hora e, se a rede
   * falhasse, ela sumia da tela e continuava no servidor.
   */
  private async deleteFile(index: number) {
    // `slotVazio` e nao `== PicturesPage.grayPlus`: o getter devolve um asset diferente em tema
    // escuro, e `this.grayPlus` e uma copia feita na criacao do componente. Comparando so com o
    // getter, virar o tema no meio da sessao fazia a guarda passar batido.
    if (this.excluindoFoto || this.slotVazio(this.pictures[index])) {
      return;
    }
    this.excluindoFoto = true;

    const loader = await this.loadingCtrl.create({
      message: this.translate.instant('pleaseWait'),
    });
    await loader.present();

    const userId = this.userData?._id?.$oid;
    const theFile: string = this.createFileName(index);
    Filesystem.deleteFile({ path: theFile, directory: Directory.Data }).then(_success => { }, _error => { });

    try {
      await firstValueFrom(this.userService.deleteFile(userId, 'picture' + index, this.userData));

      this.pictures[index] = PicturesPage.grayPlus;
      this.picChanged[index] = false;
      if (this.userData?.userValidated && index === 0) {
        this.userData.userValidated = false;
      }

      // `force`: sem ele o `hasSamePictureOrder` compara com `preShufflePictures`, que e do
      // fluxo de ARRASTAR, e podia pular a escrita — deixando a foto excluida viva no userData.
      await this.savePicturesOnUserData(this.pictures, true);
      this.preShufflePictures = [...this.pictures];

      await Preferences.set({ key: 'USER_DATA', value: JSON.stringify(this.userData) });
      this.validateProfile(true);
      console.log('delete image succesful');
    } catch (err) {
      this.util.showToastUnableToConnect(this.toastCtrl);
      console.log('deleteFile error: ' + JSON.stringify(err));
    } finally {
      await loader.dismiss();
      this.excluindoFoto = false;
    }
  }


  ionViewWillLeave() {
    void this.soltarExpansaoAposTeclado();
    // Sem isto a fila sobreviveria a saida da tela e o editor reabriria sozinho na proxima
    // entrada, com fotos de uma sessao que o usuario ja abandonou.
    this.soltarVoltarNativo?.unsubscribe();
    this.soltarVoltarNativo = undefined;
    this.limparSelecaoDeFotos();
    this.cancelarCentralizacao();
    this.soltarTransicaoDaFolha?.();
    this.soltarCromoDoEditor();
    this.showCropper = false;
    this.exitShuffleMode();
    console.log('ionViewWillLeave called..');
    if (this.hasChanged()) {
      this.save();
    }
    // Remove click listener when leaving the page
    if (this.documentClickHandler) {
      document.removeEventListener('click', this.documentClickHandler);
    }
  }

  toggleAboutMeExpansion(event: Event) {
    const target = event.target as HTMLElement;
    
    // Don't toggle if clicking directly on the textarea or its container
    if (target.closest('ion-textarea') || target.closest('ion-item') || target.closest('.charsRemaining')) {
      // Just expand if not already expanded, don't toggle
      if (!this.aboutMeExpanded) {
        this.aboutMeExpanded = true;
      }
      return;
    }
    
    event.stopPropagation();
    this.aboutMeExpanded = !this.aboutMeExpanded;
  }

  /** Listener do teclado para adiar a expansao do "sobre mim" — ver `expandAboutMe`. */
  private expandirListener?: PluginListenerHandle;
  /** Fica falso ao sair da tela, para um listener ainda registrando nao vazar. */
  private esperandoTecladoParaExpandir = false;

  /**
   * Expande o campo "sobre mim" ao receber foco.
   *
   * No ANDROID a expansao espera o teclado terminar de abrir. Este campo vai de altura normal
   * para `min-height: 500px`, e mudar o layout DURANTE a abertura do teclado e exatamente o
   * gatilho que a PR #362 identificou: o Android 16 redimensiona a janela, a skin da Samsung
   * trata o toque como fora do campo e FECHA o teclado. La o conserto foi adiar a rolagem para
   * o `keyboardDidShow`; aqui e a mesma ideia, para a expansao.
   *
   * Fora do Android segue imediato, como sempre foi — o problema nao e de la.
   */
  expandAboutMe() {
    if (this.isNative && this.platform.is('android')) {
      this.esperandoTecladoParaExpandir = true;
      void this.registrarExpansaoAposTeclado();
      return;
    }
    this.aboutMeExpanded = true;
  }

  private async registrarExpansaoAposTeclado(): Promise<void> {
    await this.expandirListener?.remove();
    this.expandirListener = undefined;
    if (!this.esperandoTecladoParaExpandir) {
      return;
    }
    try {
      const handle = await Keyboard.addListener('keyboardDidShow', () => {
        this.aboutMeExpanded = true;
      });
      if (!this.esperandoTecladoParaExpandir) {
        await handle.remove();
        return;
      }
      this.expandirListener = handle;
    } catch (error) {
      // Sem o listener, expande na hora: melhor o risco do teclado que o campo nunca abrir.
      console.log('keyboardDidShow (expandAboutMe) falhou: ' + error);
      this.aboutMeExpanded = true;
    }
  }

  private async soltarExpansaoAposTeclado(): Promise<void> {
    this.esperandoTecladoParaExpandir = false;
    await this.expandirListener?.remove();
    this.expandirListener = undefined;
  }

  handleDocumentClick(event: Event) {
    const target = event.target as HTMLElement;
    const aboutMeSection = document.querySelector('.abouteMe');
    
    // Check if click is outside the about me section
    if (aboutMeSection && !aboutMeSection.contains(target)) {
      this.aboutMeExpanded = false;
    }
  }
  private hasChanged(): boolean {
    return this.changed;
  }


  async openValidation() {
    Preferences.set({ key: 'USER_DATA', value: JSON.stringify(this.userData) }).then(async (_val) => {
      console.log('refreshed userdata stored');

      if (this.userData?.userValidated) {
        document.documentElement.style.overflow = 'hidden';
        document.body.style.overflow = 'hidden';
        const modal = this.modalCtrl.create({
          component: ProfileAlreadyValidatedComponent, cssClass: 'custom-class-modal',
          backdropDismiss: true
        });
        (await modal).present();
        (await modal).onDidDismiss();
        document.documentElement.style.overflow = '';
        document.body.style.overflow = '';
      } else {
        // Verifica se não é Android nem iOS (web) e perfil não validado
        if (!this.platform.is('android') && !this.platform.is('ios')) {
          this.showNotAvailableModal();
          return;
        }

        if (!this.userData?.hasValidPhone && !localStorage.getItem('skipStep') && !this.userData?.hasValidPoseSelfie) {
          this.backPage();
          this.router.navigate(['/home-check-profile'], { queryParams: { originValidation: '/tabs/my-profile-display' } });
        } else {
          if (this.userData?.hasValidPoseSelfie && !this.userData?.userValidated) {
            this.validateProfile(true);
          } else {
            this.validateProfile(false);
            this.backPage();
            this.router.navigate(['/instructions-check-profile'], { queryParams: { originValidation: '/tabs/my-profile-display' } });
          }
        }
      }
    });
  }

  validateProfile(verifyIsCompleted: boolean) {
    console.log(this.userData)
    const theObs = this.userService.validateProfile(this.userData);
    theObs.subscribe(async response => {
      const data = JSON.parse(response);
      if (data.result === 'notok' && verifyIsCompleted) {
        this.userData.userValidated = false;
      } else if (data.result === 'ok') {
        this.userData.userValidated = true;
      } else {
        this.userData.userValidated = false;
      }
      await Preferences.set({ key: 'USER_DATA', value: JSON.stringify(this.userData) }).then((_val) => {
        console.log('userdata saved to DB');
      })

      return;
    },
      err => {
        this.util.showToastUnableToConnect(this.toastCtrl);
        console.log('Error: ' + JSON.stringify(err));
      })
  }

  getGenderDisplayText(genderValue: string): string {
    if (!genderValue) return '';

    switch (genderValue) {
      case 'female':
        return this.translate.instant('woman');
      case 'male':
        return this.translate.instant('man');
      case 'other':
        return this.translate.instant('nonBinaryGenderDiverse');
      default:
        return genderValue; // Return as-is if it's a custom description
    }
  }
}